var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g3, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _g4, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _g5, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrowth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 259,
    viewBox: "0 0 270 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.455 125.86C283.182 156.339 283.182 205.661 230.455 236.14C177.729 266.62 92.2708 266.62 39.5446 236.14C-13.1816 205.661 -13.1816 156.339 39.5446 125.86C92.2708 95.3801 177.785 95.3801 230.455 125.86Z",
    fill: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.02381,
    d: "M211.928 220.294L85.0539 146.266C80.3005 143.61 80.9296 138.786 86.3821 135.571L103.508 126.413C108.961 123.198 117.279 122.709 122.033 125.365L248.907 199.462C253.661 202.119 253.032 206.942 247.579 210.158L230.453 219.315C225 222.53 216.682 223.02 211.928 220.294Z",
    fill: "#A7ADDA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.047619,
    d: "M211.928 220.084L85.4034 146.266C80.7199 143.61 81.2791 138.856 86.7316 135.641L103.508 126.693C108.961 123.477 117.14 123.058 121.823 125.714L248.348 199.532C253.032 202.189 252.472 206.942 247.02 210.158L230.243 219.105C224.861 222.251 216.682 222.74 211.928 220.084Z",
    fill: "#9EA5CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.071429,
    d: "M211.929 219.874L85.753 146.266C81.0695 143.61 81.6986 138.926 87.0812 135.78L103.578 126.973C108.961 123.827 117.07 123.338 121.753 125.994L247.929 199.602C252.612 202.258 251.983 206.942 246.601 210.088L230.103 218.895C224.721 222.041 216.612 222.461 211.929 219.874Z",
    fill: "#969CC4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.095238,
    d: "M211.928 219.664L86.1025 146.266C81.4889 143.679 82.0481 138.996 87.4306 135.85L103.578 127.252C108.891 124.107 117 123.687 121.613 126.274L247.439 199.672C252.053 202.258 251.494 206.942 246.111 210.088L229.964 218.686C224.581 221.761 216.542 222.251 211.928 219.664Z",
    fill: "#8E93B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.119,
    d: "M211.928 219.385L86.452 146.196C81.9083 143.61 82.4675 138.996 87.7102 135.85L103.508 127.462C108.821 124.316 116.79 123.897 121.334 126.483L246.81 199.742C251.354 202.328 250.795 206.942 245.552 210.088L229.754 218.476C224.511 221.552 216.472 221.971 211.928 219.385Z",
    fill: "#858BAE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M211.928 219.175L86.8015 146.126C82.2578 143.54 82.817 138.996 88.0598 135.92L103.578 127.741C108.821 124.666 116.72 124.176 121.264 126.763L246.391 199.812C250.935 202.398 250.375 206.942 245.133 210.018L229.614 218.196C224.371 221.272 216.472 221.761 211.928 219.175Z",
    fill: "#7D82A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1667,
    d: "M211.928 218.965L87.151 146.126C82.6772 143.61 83.2364 139.066 88.4093 135.99L103.578 128.021C108.751 124.945 116.58 124.526 121.124 127.043L245.902 199.882C250.375 202.398 249.816 206.942 244.643 210.018L229.474 217.987C224.231 221.063 216.402 221.482 211.928 218.965Z",
    fill: "#757999"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M211.928 218.686L87.5005 146.056C83.0267 143.54 83.5859 139.066 88.7588 135.99L103.578 128.161C108.751 125.155 116.51 124.666 120.914 127.182L245.342 199.812C249.816 202.328 249.257 206.802 244.084 209.878L229.264 217.707C224.092 220.783 216.332 221.202 211.928 218.686Z",
    fill: "#6C718E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2143,
    d: "M211.859 218.476L87.8501 146.056C83.4462 143.54 84.0054 139.136 89.1083 136.13L103.648 128.51C108.751 125.505 116.441 125.085 120.844 127.532L244.923 199.952C249.327 202.468 248.768 206.872 243.665 209.878L229.125 217.497C224.022 220.573 216.262 220.993 211.859 218.476Z",
    fill: "#646883"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M211.859 218.266L88.1297 146.056C83.7957 143.61 84.285 139.206 89.3181 136.2L103.508 128.79C108.541 125.784 116.161 125.365 120.565 127.881L244.294 200.092C248.628 202.538 248.138 206.942 243.105 209.948L228.915 217.358C223.882 220.294 216.263 220.713 211.859 218.266Z",
    fill: "#5C5F78"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2619,
    d: "M211.859 218.057L88.4792 145.986C84.1452 143.54 84.7044 139.206 89.6676 136.2L103.508 129C108.472 126.064 116.021 125.644 120.355 128.091L243.734 200.092C248.068 202.538 247.509 206.872 242.546 209.878L228.705 217.078C223.742 220.084 216.193 220.503 211.859 218.057Z",
    fill: "#53576D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M211.859 217.777L88.8287 145.916C84.5646 143.47 85.0539 139.206 90.0171 136.27L103.578 129.209C108.541 126.273 116.021 125.854 120.285 128.301L243.315 200.161C247.579 202.608 247.09 206.872 242.127 209.808L228.565 216.868C223.602 219.804 216.123 220.224 211.859 217.777Z",
    fill: "#4B4E62"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3095,
    d: "M211.859 217.567L89.1782 145.916C84.9141 143.54 85.4734 139.276 90.3666 136.34L103.578 129.489C108.472 126.623 115.881 126.204 120.145 128.58L242.826 200.231C247.09 202.608 246.531 206.872 241.637 209.808L228.426 216.659C223.463 219.594 216.123 219.944 211.859 217.567Z",
    fill: "#434557"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M211.859 217.358L89.5277 145.916C85.3335 143.54 85.8229 139.276 90.7161 136.41L103.578 129.769C108.402 126.903 115.741 126.483 119.936 128.86L242.267 200.301C246.461 202.678 245.971 206.942 241.078 209.808L228.216 216.449C223.393 219.315 216.053 219.734 211.859 217.358Z",
    fill: "#3A3D4C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3571,
    d: "M211.859 217.148L89.8773 145.916C85.753 143.54 86.2423 139.346 91.0657 136.549L103.648 130.118C108.472 127.252 115.742 126.903 119.866 129.21L241.777 200.441C245.902 202.818 245.412 207.012 240.589 209.808L228.006 216.239C223.253 219.035 215.983 219.455 211.859 217.148Z",
    fill: "#323441"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M211.789 216.868L90.2267 145.846C86.1024 143.54 86.6617 139.345 91.3452 136.549L103.578 130.258C108.332 127.462 115.532 127.042 119.656 129.349L241.218 200.371C245.342 202.678 244.783 206.872 240.1 209.668L227.866 215.959C223.113 218.825 215.913 219.245 211.789 216.868Z",
    fill: "#2A2B37"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4048,
    d: "M211.789 216.659L90.5762 145.846C86.5219 143.54 87.0112 139.415 91.6947 136.689L103.578 130.608C108.262 127.811 115.392 127.462 119.446 129.699L240.659 200.511C244.713 202.818 244.224 206.942 239.54 209.668L227.657 215.75C222.973 218.546 215.913 218.965 211.789 216.659Z",
    fill: "#21232C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M211.789 216.449L90.9258 145.846C86.8714 143.54 87.4307 139.485 92.0443 136.759L103.648 130.887C108.332 128.161 115.322 127.741 119.376 130.048L240.239 200.651C244.294 202.957 243.735 207.012 239.121 209.738L227.517 215.61C222.903 218.336 215.843 218.686 211.789 216.449Z",
    fill: "#191A21"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4524,
    d: "M211.789 216.239L91.2753 145.776C87.2908 143.54 87.7801 139.485 92.3938 136.759L103.648 131.097C108.262 128.371 115.252 128.021 119.237 130.258L239.75 200.72C243.734 202.957 243.245 207.012 238.632 209.738L227.377 215.4C222.763 218.057 215.773 218.476 211.789 216.239Z",
    fill: "#111116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M211.789 215.959L91.6248 145.777C87.7102 143.54 88.1996 139.555 92.7433 136.899L103.648 131.376C108.192 128.65 115.112 128.301 119.027 130.538L239.191 200.79C243.105 203.027 242.616 207.012 238.072 209.668L227.167 215.191C222.624 217.847 215.703 218.196 211.789 215.959Z",
    fill: "#08090B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M211.789 215.75L91.9743 145.707C88.0597 143.54 88.5491 139.555 93.0928 136.899L103.648 131.586C108.192 128.93 114.973 128.51 118.887 130.747L238.701 200.791C242.616 202.958 242.127 206.942 237.583 209.598L227.028 214.911C222.484 217.567 215.703 217.987 211.789 215.75Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.804 198.554H242.896C242.406 197.994 241.777 197.435 241.008 196.946L118.887 125.644C114.693 123.268 107.423 123.687 102.6 126.553L89.8773 133.054C88.619 133.823 87.6403 134.662 86.9413 135.571H85.8928V142.351C86.0326 143.749 86.9413 145.077 88.6889 146.056L210.81 217.358C215.004 219.734 222.274 219.315 227.098 216.449L239.82 209.878C242.127 208.55 243.385 206.872 243.734 205.264H243.804V198.554Z",
    fill: "url(#paint0_linear_334_2901)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.81 211.276L88.6889 139.975C84.4947 137.598 85.0539 133.404 89.8773 130.538L102.6 123.967C107.423 121.101 114.693 120.681 118.887 123.058L241.008 194.359C245.202 196.736 244.643 200.93 239.82 203.796L227.098 210.367C222.274 213.233 215.004 213.653 210.81 211.276Z",
    fill: "url(#paint1_linear_334_2901)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M239.82 203.097L227.098 209.668C222.274 212.534 215.004 212.954 210.81 210.577L88.6889 139.276C87.0113 138.297 86.1025 137.109 85.8928 135.78C85.6132 137.528 86.5219 139.206 88.6889 140.394L210.81 211.695C215.004 214.072 222.274 213.653 227.098 210.787L239.82 204.216C242.686 202.538 244.014 200.301 243.735 198.344C243.525 199.952 242.197 201.699 239.82 203.097Z",
    fill: "url(#paint2_radial_334_2901)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.02381,
    d: "M97.0773 232.457L57.3722 209.529C52.6887 206.802 53.2479 202.049 58.7004 198.973L71.283 191.703C76.7354 188.558 84.9141 188.208 89.5977 190.934L129.303 213.863C133.986 216.589 133.427 221.342 127.975 224.418L115.392 231.688C109.94 234.834 101.761 235.183 97.0773 232.457Z",
    fill: "#A7ADDA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.047619,
    d: "M97.0773 232.247L57.7217 209.529C53.0382 206.872 53.6673 202.119 59.0499 199.043L71.3528 191.983C76.7354 188.907 84.8442 188.558 89.5277 191.214L128.883 213.933C133.567 216.589 132.938 221.342 127.555 224.418L115.252 231.478C109.87 234.624 101.691 234.973 97.0773 232.247Z",
    fill: "#9EA5CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.071429,
    d: "M97.0773 232.038L58.0712 209.529C53.4576 206.872 54.0168 202.189 59.3295 199.113L71.2829 192.263C76.5956 189.187 84.6345 188.837 89.2481 191.494L128.254 214.002C132.868 216.659 132.309 221.342 126.996 224.418L115.042 231.269C109.73 234.344 101.691 234.694 97.0773 232.038Z",
    fill: "#969CC4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.095238,
    d: "M97.0773 231.828L58.4207 209.529C53.877 206.872 54.4362 202.259 59.679 199.253L71.2829 192.542C76.5956 189.466 84.5646 189.187 89.1083 191.773L127.765 214.072C132.309 216.729 131.749 221.342 126.507 224.348L114.903 231.059C109.59 234.135 101.621 234.484 97.0773 231.828Z",
    fill: "#8E93B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.119,
    d: "M97.0074 231.618L58.7003 209.529C54.1566 206.942 54.7158 202.329 59.9586 199.323L71.2829 192.822C76.5257 189.816 84.4248 189.466 88.9685 192.123L127.276 214.212C131.819 216.799 131.26 221.412 126.017 224.418L114.693 230.919C109.45 233.855 101.551 234.205 97.0074 231.618Z",
    fill: "#858BAE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M97.0074 231.338L59.1198 209.459C54.646 206.872 55.2052 202.329 60.378 199.323L71.3529 193.031C76.5257 190.026 84.3549 189.746 88.8287 192.332L126.786 214.212C131.26 216.799 130.701 221.342 125.528 224.348L114.553 230.639C109.38 233.645 101.551 233.925 97.0074 231.338Z",
    fill: "#7D82A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1667,
    d: "M97.0073 231.129L59.3993 209.459C54.9255 206.872 55.4848 202.399 60.6576 199.463L71.2829 193.311C76.3858 190.375 84.215 190.026 88.6189 192.612L126.227 214.282C130.701 216.869 130.142 221.342 124.969 224.278L114.343 230.43C109.24 233.366 101.481 233.715 97.0073 231.129Z",
    fill: "#757999"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M97.0073 230.919L59.8188 209.389C55.4148 206.872 55.9741 202.399 61.077 199.463L71.4227 193.521C76.5257 190.585 84.215 190.235 88.6189 192.822L125.807 214.282C130.211 216.799 129.652 221.272 124.549 224.208L114.204 230.15C109.101 233.156 101.411 233.436 97.0073 230.919Z",
    fill: "#6C718E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2143,
    d: "M97.0074 230.709L60.1683 209.389C55.8343 206.872 56.3236 202.468 61.3567 199.532L71.3528 193.8C76.3859 190.864 84.0053 190.585 88.4092 193.101L125.248 214.422C129.582 216.938 129.093 221.342 124.06 224.278L114.064 230.01C108.961 232.876 101.341 233.226 97.0074 230.709Z",
    fill: "#646883"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M97.0073 230.43L60.5178 209.319C56.1838 206.802 56.743 202.468 61.7061 199.602L71.4227 194.01C76.3858 191.144 83.9354 190.795 88.2694 193.311L124.759 214.422C129.093 216.938 128.534 221.272 123.571 224.138L113.854 229.731C108.891 232.667 101.341 232.946 97.0073 230.43Z",
    fill: "#5C5F78"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2619,
    d: "M97.0074 230.22L60.8673 209.319C56.6032 206.872 57.0925 202.538 62.0557 199.672L71.4227 194.29C76.3859 191.424 83.8655 191.144 88.1296 193.591L124.27 214.492C128.534 216.938 128.044 221.272 123.081 224.138L113.714 229.521C108.751 232.387 101.271 232.737 97.0074 230.22Z",
    fill: "#53576D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M97.0074 230.01L61.2169 209.319C56.9528 206.872 57.512 202.608 62.4052 199.742L71.4227 194.569C76.316 191.773 83.7257 191.424 87.9898 193.87L123.78 214.562C128.044 217.008 127.485 221.272 122.592 224.138L113.574 229.311C108.611 232.177 101.202 232.457 97.0074 230.01Z",
    fill: "#4B4E62"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3095,
    d: "M96.9375 229.801L61.4965 209.319C57.3023 206.872 57.7916 202.678 62.6848 199.882L71.4228 194.849C76.2461 192.053 83.5859 191.773 87.7801 194.15L123.221 214.632C127.415 217.078 126.926 221.273 122.033 224.069L113.295 229.102C108.472 231.898 101.132 232.177 96.9375 229.801Z",
    fill: "#434557"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M96.9375 229.521L61.846 209.249C57.7217 206.872 58.211 202.678 63.0344 199.882L71.4228 195.059C76.2461 192.263 83.516 191.983 87.6403 194.36L122.732 214.632C126.856 217.008 126.367 221.203 121.543 223.999L113.155 228.822C108.402 231.688 101.132 231.968 96.9375 229.521Z",
    fill: "#3A3D4C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3571,
    d: "M96.9375 229.311L62.1955 209.249C58.0712 206.872 58.6305 202.748 63.314 199.952L71.3529 195.338C76.1063 192.612 83.3064 192.262 87.4306 194.639L122.173 214.701C126.297 217.078 125.738 221.202 121.054 223.999L113.015 228.612C108.262 231.408 101.062 231.688 96.9375 229.311Z",
    fill: "#323441"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M96.9375 229.102L62.5451 209.249C58.4907 206.872 58.98 202.818 63.6635 200.092L71.4228 195.618C76.1063 192.892 83.2364 192.612 87.2908 194.989L121.683 214.841C125.738 217.218 125.248 221.272 120.565 223.999L112.806 228.473C108.122 231.129 100.992 231.478 96.9375 229.102Z",
    fill: "#2A2B37"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4048,
    d: "M96.9374 228.892L62.8945 209.249C58.8401 206.942 59.3993 202.888 64.013 200.162L71.4227 195.897C76.1062 193.241 83.0966 192.892 87.151 195.268L121.194 214.911C125.248 217.218 124.689 221.272 120.075 223.999L112.666 228.263C107.982 230.919 100.992 231.199 96.9374 228.892Z",
    fill: "#21232C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M96.9375 228.682L63.2441 209.179C59.2596 206.872 59.7489 202.818 64.3625 200.162L71.4228 196.107C76.0364 193.451 83.0267 193.171 87.0112 195.478L120.705 214.981C124.689 217.288 124.2 221.342 119.586 223.999L112.526 228.053C107.912 230.639 100.922 230.989 96.9375 228.682Z",
    fill: "#191A21"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4524,
    d: "M96.9375 228.403L63.5936 209.109C59.6091 206.802 60.1683 202.818 64.712 200.232L71.4926 196.317C76.0364 193.661 82.9568 193.381 86.8714 195.688L120.215 214.981C124.13 217.288 123.641 221.272 119.097 223.859L112.316 227.773C107.772 230.43 100.852 230.709 96.9375 228.403Z",
    fill: "#111116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M96.8676 228.193L63.8732 209.109C59.9586 206.872 60.4479 202.888 64.9916 200.302L71.4228 196.597C75.9665 194.01 82.7471 193.731 86.6617 195.967L119.656 215.051C123.571 217.288 123.081 221.272 118.538 223.859L112.106 227.564C107.633 230.15 100.782 230.43 96.8676 228.193Z",
    fill: "#08090B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M96.8675 227.983L64.2227 209.109C60.378 206.872 60.8673 202.958 65.2712 200.371L71.4227 196.876C75.8965 194.29 82.6073 194.01 86.5219 196.247L119.167 215.121C123.011 217.358 122.522 221.272 118.118 223.859L111.967 227.354C107.493 229.94 100.782 230.22 96.8675 227.983Z",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.27 212.954H123.361C122.872 212.395 122.312 211.835 121.474 211.346L86.5218 191.214C82.3976 188.837 75.1975 189.117 70.3742 191.913L62.1955 196.597C60.9372 197.296 59.9586 198.134 59.3294 199.043H58.2809V205.754C58.4207 207.152 59.3294 208.48 61.077 209.459L96.0287 229.591C100.153 231.968 107.353 231.688 112.176 228.892L120.355 224.208C122.592 222.88 123.92 221.272 124.2 219.665H124.27V212.954Z",
    fill: "url(#paint3_linear_334_2901)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9589 223.509L61.0072 203.377C56.8829 201 57.3722 196.806 62.1955 194.08L70.3742 189.396C75.1277 186.67 82.3976 186.321 86.5219 188.697L121.474 208.83C125.598 211.206 125.109 215.4 120.285 218.127L112.107 222.81C107.283 225.606 100.083 225.886 95.9589 223.509Z",
    fill: "url(#paint4_linear_334_2901)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.285 217.428L112.106 222.111C107.353 224.837 100.083 225.187 95.9588 222.81L61.0072 202.678C59.3295 201.7 58.4207 200.441 58.2809 199.183C58.0013 200.931 58.9101 202.608 61.0072 203.797L95.9588 223.929C100.083 226.305 107.283 226.026 112.106 223.23L120.285 218.546C123.151 216.869 124.479 214.771 124.2 212.744C123.92 214.352 122.662 216.1 120.285 217.428Z",
    fill: "url(#paint5_radial_334_2901)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M124.27 206.243H123.361C122.872 205.684 122.312 205.125 121.474 204.635L86.5219 184.503C82.3976 182.126 75.1976 182.406 70.3742 185.202L62.1955 189.886C60.9373 190.585 59.9586 191.424 59.3295 192.332H58.2809V199.043C58.4208 200.441 59.3295 201.769 61.0771 202.748L96.0287 222.88C100.153 225.257 107.353 224.977 112.176 222.181L120.355 217.498C122.592 216.169 123.92 214.562 124.2 212.954H124.27V206.243Z",
    fill: "url(#paint6_linear_334_2901)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.27 204.705H123.361C122.872 204.146 122.312 203.587 121.474 203.097L86.5219 182.965C82.3976 180.589 75.1976 180.868 70.3742 183.664L62.1955 188.348C60.9373 189.047 59.9586 189.886 59.3295 190.794H58.2809V197.505C58.4208 198.903 59.3295 200.231 61.0771 201.21L96.0287 221.342C100.153 223.719 107.353 223.439 112.176 220.643L120.355 215.96C122.592 214.632 123.92 213.024 124.2 211.416H124.27V204.705Z",
    fill: "url(#paint7_linear_334_2901)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9589 215.331L61.0072 195.198C56.8829 192.822 57.3722 188.627 62.1955 185.901L70.3742 181.218C75.1277 178.491 82.3976 178.142 86.5219 180.519L121.474 200.651C125.598 203.028 125.109 207.222 120.285 209.948L112.107 214.632C107.283 217.428 100.083 217.707 95.9589 215.331Z",
    fill: "url(#paint8_linear_334_2901)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.285 209.249L112.106 213.933C107.353 216.659 100.083 217.008 95.9588 214.632L61.0072 194.499C59.3295 193.521 58.4207 192.263 58.2809 191.004C58.0013 192.752 58.9101 194.43 61.0072 195.618L95.9588 215.75C100.083 218.127 107.283 217.847 112.106 215.051L120.285 210.368C123.151 208.69 124.479 206.593 124.2 204.566C123.92 206.173 122.662 207.851 120.285 209.249Z",
    fill: "url(#paint9_radial_334_2901)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M243.804 191.633H242.896C242.406 191.074 241.777 190.515 241.008 190.026L118.887 118.724C114.693 116.347 107.423 116.767 102.6 119.633L89.8773 126.204C88.619 126.973 87.6403 127.812 86.9413 128.72H85.8928V135.501C86.0326 136.899 86.9413 138.227 88.6889 139.206L210.81 210.507C215.004 212.884 222.274 212.465 227.098 209.598L239.82 203.028C242.127 201.699 243.385 200.022 243.734 198.414H243.804V191.633Z",
    fill: "url(#paint10_linear_334_2901)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M243.804 190.235H242.896C242.406 189.676 241.777 189.117 241.008 188.627L118.887 117.326C114.693 114.949 107.423 115.369 102.6 118.235L89.8773 124.806C88.619 125.575 87.6403 126.414 86.9413 127.322H85.8928V134.103C86.0326 135.501 86.9413 136.829 88.6889 137.808L210.81 209.109C215.004 211.486 222.274 211.066 227.098 208.2L239.82 201.629C242.127 200.301 243.385 198.624 243.734 197.016H243.804V190.235Z",
    fill: "url(#paint11_linear_334_2901)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M210.81 202.958L88.6888 131.656C84.4946 129.28 85.0539 125.085 89.8772 122.219L102.6 115.648C107.423 112.782 114.693 112.363 118.887 114.74L241.008 186.041C245.202 188.418 244.643 192.612 239.82 195.478L227.097 202.049C222.274 204.915 215.004 205.334 210.81 202.958Z",
    fill: "url(#paint12_linear_334_2901)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M239.82 194.849L227.097 201.42C222.274 204.286 215.004 204.705 210.81 202.329L88.6889 130.957C87.0112 129.979 86.1024 128.79 85.8927 127.462C85.6131 129.21 86.5219 130.887 88.6889 132.076L210.81 203.377C215.004 205.754 222.274 205.334 227.097 202.468L239.82 195.897C242.686 194.22 244.014 191.983 243.734 190.026C243.525 191.703 242.197 193.451 239.82 194.849Z",
    fill: "url(#paint13_radial_334_2901)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.047619,
    d: "M99.0345 115.578C100.642 114.67 102.879 114.04 104.906 113.971C106.794 113.901 108.471 114.32 109.8 115.019C109.87 115.019 113.015 116.837 113.085 116.837L172.153 150.74L176.208 153.047L234.437 186.53C236.185 187.509 237.303 189.187 237.373 190.934C237.443 192.891 236.255 194.779 234.088 196.037L229.404 198.484C229.334 198.484 225.35 200.581 225.28 200.581C223.602 201.49 221.505 202.049 219.338 201.979C217.521 201.979 215.703 201.49 214.445 200.721L156.215 166.748L152.72 164.72L97.986 132.844C96.2384 131.866 95.05 130.188 95.05 128.441C95.05 126.553 96.0287 124.596 98.0559 123.408L98.1258 122.149C98.1258 122.079 98.8947 115.648 99.0345 115.578Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.095238,
    d: "M99.0345 116.068C100.572 115.159 102.879 114.53 104.836 114.46C106.654 114.32 108.402 114.74 109.73 115.439C109.87 115.439 112.875 117.186 113.015 117.186L171.804 150.949L175.788 153.256L233.808 186.6C235.416 187.509 236.744 189.256 236.814 190.934C236.884 192.891 235.835 194.779 233.668 196.037L228.985 198.484C228.845 198.554 225 200.511 224.86 200.511C223.183 201.42 221.086 201.909 219.059 201.839C217.381 201.839 215.424 201.28 214.235 200.581L156.355 166.887L152.86 164.86L98.5452 133.054C96.9374 132.145 95.6093 130.398 95.6093 128.72C95.6093 126.903 96.2384 124.945 98.2656 123.827L98.3355 122.569C98.0559 122.499 98.8248 116.207 99.0345 116.068Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M99.1045 116.627C100.572 115.788 102.949 115.089 104.767 114.949C106.584 114.809 108.262 115.159 109.66 115.788C109.87 115.788 112.806 117.396 112.945 117.466L171.524 151.089L175.509 153.396L233.249 186.6C234.787 187.509 236.185 189.257 236.325 190.864C236.465 192.752 235.486 194.639 233.319 195.897L228.705 198.344C228.565 198.414 224.791 200.301 224.581 200.301C222.903 201.14 220.876 201.56 218.849 201.49C217.241 201.49 215.214 200.791 214.095 200.161L156.635 166.678L153.21 164.651L99.1744 133.194C97.6365 132.285 96.1685 130.538 96.1685 129C96.1685 127.252 96.518 125.295 98.4054 124.177V122.988C98.0559 122.848 98.755 116.837 99.1045 116.627Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M99.1045 117.116C100.503 116.347 102.949 115.578 104.697 115.369C106.444 115.159 108.192 115.509 109.59 116.138C109.8 116.138 112.666 117.676 112.875 117.815L171.175 151.369L175.159 153.676L232.69 186.74C234.158 187.579 235.696 189.396 235.835 190.864C236.045 192.752 235.136 194.639 232.969 195.897L228.426 198.344C228.216 198.484 224.581 200.231 224.371 200.231C222.694 201.07 220.666 201.42 218.779 201.35C217.241 201.35 215.144 200.581 214.026 199.952L156.915 166.678L153.489 164.651L99.6637 133.404C98.1957 132.565 96.588 130.747 96.588 129.279C96.588 127.672 96.6579 125.575 98.4054 124.596L98.3355 123.408C97.986 123.198 98.6851 117.396 99.1045 117.116Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M99.1743 117.676C100.502 116.907 103.019 116.138 104.627 115.858C106.374 115.578 108.052 115.928 109.45 116.487C109.73 116.487 112.526 117.955 112.736 118.095L170.825 151.509L174.81 153.816L232.13 186.74C233.529 187.509 235.206 189.396 235.346 190.794C235.556 192.612 234.787 194.499 232.62 195.758L228.076 198.204C227.796 198.344 224.301 200.022 224.022 200.092C222.344 200.861 220.387 201.21 218.499 201.07C217.031 201.07 214.864 200.231 213.816 199.602L156.984 166.678L153.559 164.72L100.223 133.683C98.8248 132.914 97.0772 131.027 97.0772 129.629C97.0772 128.091 96.8675 125.994 98.5452 125.085L98.4054 123.967C97.9161 123.617 98.6151 118.025 99.1743 117.676Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M99.2443 118.235C100.433 117.536 103.089 116.697 104.627 116.417C106.305 116.068 108.052 116.417 109.45 116.976C109.8 116.976 112.456 118.374 112.736 118.514L170.616 151.788L174.53 154.025L231.571 186.88C232.83 187.649 234.647 189.536 234.857 190.864C235.136 192.682 234.437 194.569 232.27 195.827L227.797 198.344C227.447 198.554 224.162 200.161 223.742 200.161C222.064 200.86 220.177 201.21 218.29 201C216.962 201 214.655 200.091 213.676 199.532L157.264 166.678L153.909 164.72L100.852 133.753C99.5938 132.984 97.6365 131.167 97.6365 129.839C97.6365 128.441 97.1472 126.274 98.6851 125.365L98.5452 124.246C97.9161 123.967 98.5452 118.584 99.2443 118.235Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M99.2443 118.724C100.363 118.095 103.089 117.116 104.487 116.837C106.165 116.487 107.842 116.767 109.31 117.256C109.73 117.256 112.316 118.584 112.596 118.794L170.196 151.928L174.111 154.165L230.942 186.88C232.131 187.579 234.298 189.536 234.298 190.725C234.997 192.472 234.088 194.36 231.851 195.688L227.447 198.204C227.097 198.414 223.882 199.952 223.393 199.952C221.785 200.651 219.828 200.93 218.08 200.721C216.822 200.721 214.375 199.672 213.466 199.183L157.404 166.538L154.049 164.581L101.341 133.963C100.153 133.264 98.056 131.377 98.056 130.118C98.056 128.79 97.287 126.623 98.6851 125.784L98.4754 124.736C97.8462 124.316 98.4754 119.213 99.2443 118.724Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M99.3142 119.283C100.363 118.654 103.159 117.675 104.487 117.326C106.095 116.907 107.842 117.186 109.24 117.675C109.73 117.675 112.176 118.934 112.526 119.143L169.917 152.138L173.831 154.375L230.453 186.95C231.571 187.579 233.948 189.606 233.948 190.724C234.717 192.402 233.878 194.359 231.641 195.618L227.237 198.134C226.818 198.344 223.742 199.812 223.183 199.882C221.575 200.511 219.688 200.791 217.94 200.511C216.752 200.511 214.235 199.392 213.396 198.903L157.683 166.538L154.328 164.581L101.97 134.173C100.852 133.544 98.6151 131.586 98.6151 130.468C98.6151 129.21 97.5666 126.973 98.8947 126.204L98.6151 125.155C97.7763 124.736 98.4054 119.773 99.3142 119.283Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M99.3142 119.842C100.293 119.283 103.159 118.235 104.347 117.815C105.955 117.326 107.703 117.536 109.101 118.025C109.66 118.025 111.967 119.213 112.386 119.423L169.497 152.348L173.412 154.584L229.754 187.02C230.802 187.649 233.319 189.676 233.319 190.724C234.158 192.402 233.389 194.29 231.152 195.618L226.818 198.134C226.329 198.414 223.393 199.742 222.833 199.812C221.226 200.441 219.338 200.651 217.661 200.371C216.612 200.371 213.956 199.183 213.187 198.763L157.823 166.608L154.468 164.65L102.46 134.452C101.411 133.823 99.0346 131.866 99.0346 130.817C99.0346 129.699 97.6365 127.392 98.8947 126.693L98.5452 125.714C97.7763 125.085 98.3355 120.402 99.3142 119.842Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M99.3841 120.332C100.293 119.842 103.229 118.654 104.347 118.305C105.885 117.745 107.633 117.955 109.101 118.374C109.66 118.374 111.967 119.493 112.386 119.703L169.287 152.487L173.202 154.724L229.334 187.02C230.313 187.579 232.969 189.676 232.969 190.585C233.948 192.192 233.179 194.15 230.942 195.408L226.678 197.924C226.119 198.204 223.323 199.532 222.694 199.532C221.086 200.091 219.268 200.231 217.66 199.952C216.682 199.952 213.956 198.693 213.257 198.274L158.243 166.328L154.957 164.441L103.299 134.452C102.32 133.893 99.8035 131.866 99.8035 130.957C99.8035 129.909 98.1258 127.602 99.3142 126.903L98.8947 125.924C97.7064 125.435 98.2656 120.961 99.3841 120.332Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M99.3841 120.891C100.223 120.402 103.229 119.143 104.207 118.794C105.745 118.235 107.493 118.374 108.961 118.794C109.59 118.794 111.757 119.842 112.246 120.122L168.868 152.767L172.713 155.004L228.566 187.229C229.404 187.719 232.27 189.886 232.27 190.724C233.319 192.262 232.62 194.22 230.383 195.548L226.119 198.064C225.56 198.414 222.833 199.602 222.134 199.672C220.527 200.161 218.779 200.301 217.171 200.022C216.262 200.022 213.466 198.623 212.767 198.274L158.103 166.538L154.817 164.65L103.508 134.872C102.67 134.382 99.9433 132.285 99.9433 131.446C99.9433 130.468 97.986 128.161 99.0346 127.532L98.6152 126.623C97.7064 125.854 98.1958 121.59 99.3841 120.891Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M99.454 121.38C100.153 120.961 103.369 119.563 104.207 119.213C105.675 118.584 107.423 118.724 108.891 119.073C109.59 119.073 111.687 120.052 112.176 120.332L168.588 152.837L172.433 155.074L228.076 187.159C228.845 187.579 231.851 189.816 231.851 190.585C232.969 192.122 232.34 194.08 230.033 195.338L225.839 197.855C225.21 198.204 222.624 199.322 221.855 199.392C220.247 199.882 218.499 199.952 216.961 199.602C216.123 199.602 213.187 198.134 212.627 197.785L158.382 166.258L155.097 164.371L104.137 134.802C103.369 134.382 100.503 132.285 100.503 131.446C100.503 130.608 98.2656 128.161 99.1743 127.672L98.685 126.763C97.6365 126.204 98.1258 122.149 99.454 121.38Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M99.5239 121.94C100.153 121.59 103.438 120.122 104.137 119.703C105.605 119.004 107.353 119.144 108.821 119.493C109.59 119.493 111.547 120.402 112.106 120.681L168.309 153.047L172.153 155.284L227.587 187.229C228.286 187.649 231.431 189.886 231.431 190.585C232.69 192.053 232.061 194.01 229.754 195.338L225.629 197.855C224.93 198.274 222.554 199.253 221.715 199.323C220.107 199.742 218.429 199.812 216.961 199.462C216.262 199.462 213.187 197.925 212.697 197.645L158.802 166.328L155.586 164.441L104.976 135.081C104.277 134.662 101.271 132.565 101.271 131.866C101.271 131.097 98.7549 128.65 99.5938 128.161L99.0346 127.322C97.5666 126.553 98.0559 122.778 99.5239 121.94Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M99.5239 122.499C100.083 122.149 103.438 120.541 104.068 120.262C105.466 119.563 107.213 119.633 108.751 119.912C109.59 119.912 111.477 120.681 112.037 121.031L167.959 153.326L171.804 155.563L226.958 187.369C227.587 187.719 230.872 190.025 230.872 190.585C232.2 192.053 231.641 194.01 229.334 195.338L225.21 197.924C224.441 198.344 222.204 199.323 221.295 199.323C219.758 199.742 218.01 199.742 216.612 199.323C215.983 199.323 212.837 197.715 212.418 197.435L158.872 166.398L155.656 164.511L105.326 135.361C104.697 135.011 101.551 132.844 101.551 132.215C101.551 131.516 98.755 129.07 99.454 128.65L98.8248 127.811C97.5666 126.973 97.986 123.338 99.5239 122.499Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M99.5937 122.988C100.083 122.708 103.508 120.961 103.998 120.681C105.326 119.912 107.143 119.982 108.611 120.262C109.52 120.262 111.268 120.961 111.897 121.38L167.61 153.536L171.384 155.703L226.329 187.369C226.818 187.649 230.313 189.955 230.313 190.515C231.781 191.913 231.222 193.87 228.915 195.198L224.861 197.785C224.092 198.274 221.925 199.113 220.946 199.183C219.408 199.532 217.73 199.532 216.332 199.043C215.773 199.043 212.558 197.365 212.138 197.086L159.081 166.258L155.866 164.371L105.955 135.431C105.466 135.151 102.11 132.914 102.11 132.425C102.11 131.866 98.9646 129.279 99.5937 128.93L98.9646 128.161C97.4966 127.322 97.9161 123.967 99.5937 122.988Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M99.5938 123.547C100.013 123.338 103.369 121.171 103.928 121.171C105.396 120.612 107.004 120.402 108.541 120.612C109.52 120.612 111.198 121.241 111.827 121.66L167.26 153.676L171.035 155.843L225.699 187.439C226.119 187.719 229.754 190.026 229.754 190.515C231.292 191.843 230.802 193.87 228.496 195.198L224.511 197.785C223.672 198.274 221.645 199.043 220.596 199.113C219.059 199.393 217.451 199.393 216.123 198.903C215.703 198.903 212.348 197.086 211.998 196.946L159.151 166.328L155.936 164.511L106.305 135.781C105.885 135.501 102.39 133.264 102.39 132.845C102.39 132.355 98.9647 129.769 99.5239 129.489L98.8249 128.72C97.4967 127.672 97.8462 124.526 99.5938 123.547Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M99.6637 124.037C100.013 123.827 103.438 121.59 103.858 121.59C105.256 120.961 106.934 120.751 108.472 120.891C109.45 120.891 111.058 121.45 111.757 121.87L166.981 153.746L170.755 155.913L225.21 187.369C225.56 187.579 229.404 189.955 229.404 190.305C231.012 191.633 230.593 193.66 228.286 194.919L224.301 197.505C223.393 197.994 221.505 198.693 220.387 198.763C218.849 199.043 217.241 198.903 215.983 198.414C215.633 198.414 212.208 196.526 211.928 196.387L159.431 165.979L156.285 164.161L107.004 135.641C106.654 135.431 103.019 133.124 103.019 132.775C103.019 132.425 99.3142 129.769 99.7336 129.559L98.9647 128.86C97.4268 128.091 97.7763 125.155 99.6637 124.037Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M99.7335 124.596C99.9433 124.456 103.508 122.149 103.858 122.149C105.256 121.52 106.934 121.241 108.471 121.38C109.52 121.38 110.988 121.87 111.757 122.289L166.771 154.025L170.546 156.192L224.791 187.509C225.07 187.649 229.055 190.095 229.055 190.375C230.802 191.633 230.383 193.66 228.076 194.989L224.161 197.575C223.183 198.134 221.435 198.763 220.317 198.833C218.779 199.043 217.241 198.903 215.983 198.414C215.703 198.414 212.138 196.457 211.998 196.317L159.85 166.119L156.705 164.301L107.772 135.99C107.493 135.85 103.718 133.544 103.718 133.264C103.718 132.984 99.7335 130.328 100.013 130.118L99.1743 129.419C97.3568 128.441 97.7063 125.714 99.7335 124.596Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M99.7336 125.155C99.8734 125.085 103.508 122.639 103.718 122.639C105.046 121.94 106.724 121.66 108.262 121.73C109.38 121.73 110.778 122.149 111.547 122.639L166.282 154.305L170.056 156.472L224.092 187.579C224.231 187.649 228.426 190.165 228.426 190.375C230.243 191.633 229.894 193.66 227.587 194.989L223.672 197.575C222.694 198.134 221.016 198.693 219.828 198.763C218.29 198.973 216.752 198.763 215.633 198.204C215.424 198.204 211.789 196.177 211.649 196.107L159.85 166.119L156.705 164.301L108.122 136.2C107.982 136.13 103.998 133.753 103.998 133.544C103.998 133.334 99.7336 130.608 99.9433 130.538L99.0345 129.909C97.3569 128.79 97.6365 126.344 99.7336 125.155Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M99.8035 125.645C99.8734 125.575 103.578 123.058 103.718 123.058C105.046 122.359 106.724 122.01 108.262 122.079C109.45 122.079 110.708 122.429 111.547 122.918L166.072 154.445L169.777 156.612L223.532 187.649C223.602 187.719 227.936 190.235 227.936 190.305C229.824 191.493 229.544 193.521 227.237 194.849L223.393 197.435C222.344 198.064 220.806 198.484 219.548 198.554C218.01 198.694 216.542 198.484 215.424 197.925C215.354 197.925 211.579 195.758 211.509 195.758L160.13 166.049L157.054 164.231L108.821 136.34C108.751 136.27 104.697 133.893 104.697 133.823C104.697 133.753 100.153 130.957 100.223 130.887L99.3142 130.258C97.287 129.21 97.5666 126.903 99.8035 125.645Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.214 197.785L157.194 164.231L99.1744 130.677C97.1472 129.489 97.4268 127.462 99.7336 126.134L103.508 123.477C105.815 122.149 109.38 122.009 111.338 123.128L169.357 156.681L227.377 190.235C229.404 191.423 229.125 193.451 226.818 194.779L223.043 197.435C220.736 198.763 217.241 198.973 215.214 197.785Z",
    fill: "#5B58A3"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M215.563 197.016L102.25 131.516C96.4482 128.161 91.7646 119.213 91.7646 111.454V14.2885C91.7646 6.59915 96.4482 3.03408 102.25 6.38944L215.563 71.8889C221.365 75.2442 226.049 84.1918 226.049 91.9511V189.117C226.049 196.806 221.365 200.371 215.563 197.016Z",
    fill: "url(#paint14_linear_334_2901)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M218.639 193.591L103.508 127.043C98.6851 123.967 95.7491 117.885 95.7491 111.664V11.2827C95.7491 9.81476 97.3569 8.90602 98.6152 9.60505C98.755 9.67495 98.8948 9.74485 98.9647 9.81476L214.165 76.4326C219.897 79.7181 221.925 85.59 221.925 91.8114V191.913C221.925 193.521 220.177 194.499 218.849 193.73C218.779 193.661 218.709 193.661 218.639 193.591Z",
    fill: "#5D55EC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M214.165 76.4325L98.9647 9.81465C98.8948 9.74475 98.755 9.67485 98.6152 9.60495C97.3569 8.83601 95.7491 9.74475 95.7491 11.2826V111.664C95.7491 117.885 98.755 124.037 103.508 127.043L218.639 193.591C218.709 193.591 218.779 193.66 218.919 193.73C220.317 194.499 221.995 193.521 221.995 191.913V91.8113C221.995 85.5899 219.897 79.718 214.165 76.4325ZM220.736 191.913C220.736 192.472 220.317 192.752 219.897 192.752C219.758 192.752 219.618 192.682 219.478 192.612L104.068 126.064C99.7336 123.338 96.8676 117.676 96.8676 111.734V11.2826C96.8676 10.8632 97.2171 10.5836 97.5666 10.5836C97.7064 10.5836 97.7763 10.5836 97.9162 10.6535L213.606 77.4811C219.548 80.9064 220.806 87.1977 220.806 91.8113V191.913H220.736Z",
    fill: "#AFB6E5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M220.387 69.0927L107.073 3.66318C104.767 2.33502 102.67 2.1253 100.922 2.75443C100.712 2.82434 95.889 5.62047 95.7491 5.76028C97.5666 4.92144 99.8036 5.06125 102.25 6.45931L215.563 71.9587C221.365 75.3141 226.049 84.2617 226.049 92.021V189.187C226.049 194.01 224.231 197.226 221.435 198.134C221.645 198.134 221.925 198.064 222.344 197.855C222.484 197.785 227.517 194.779 227.657 194.709C229.684 193.311 230.872 190.445 230.872 186.46V89.2948C230.872 81.3957 226.189 72.4481 220.387 69.0927Z",
    fill: "url(#paint15_linear_334_2901)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M220.317 69.1626L107.004 3.66318C104.697 2.33502 102.6 2.1253 100.852 2.75443C100.642 2.82434 95.9589 5.55057 95.7491 5.69038C97.5666 4.85154 99.8036 4.99134 102.25 6.38941L215.563 71.8888C221.365 75.2442 226.049 84.1918 226.049 91.9511V189.117C226.049 193.94 224.231 197.156 221.435 198.064C221.645 198.064 221.925 197.994 222.344 197.785C222.484 197.715 227.447 194.779 227.517 194.639C229.544 193.241 230.732 190.375 230.732 186.39V89.2249C230.802 81.4656 226.119 72.518 220.317 69.1626Z",
    fill: "url(#paint16_linear_334_2901)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M220.247 69.2326L106.934 3.73313C104.627 2.40496 102.53 2.19525 100.782 2.82438C100.572 2.89428 95.9589 5.55061 95.7491 5.69042C97.5666 4.85158 99.8036 4.99139 102.25 6.38945L215.563 71.8889C221.365 75.2442 226.049 84.1919 226.049 91.9511V189.117C226.049 193.94 224.231 197.156 221.435 198.064C221.645 198.064 221.925 197.995 222.344 197.785C222.484 197.715 227.307 194.779 227.447 194.709C229.474 193.311 230.663 190.445 230.663 186.46V89.2948C230.733 81.5355 225.979 72.5879 220.247 69.2326Z",
    fill: "url(#paint17_linear_334_2901)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M220.107 69.3024L106.794 3.80295C104.487 2.47478 102.39 2.26508 100.642 2.89421C100.433 2.96411 95.8889 5.55053 95.6792 5.69034C97.4967 4.8515 99.7336 4.99131 102.18 6.38937L215.494 71.8888C221.296 75.2442 225.979 84.1918 225.979 91.9511V189.117C225.979 193.94 224.162 197.156 221.365 198.064C221.575 198.064 221.855 197.994 222.274 197.785C222.414 197.715 227.167 194.849 227.307 194.779C229.334 193.381 230.523 190.515 230.523 186.53V89.3646C230.593 81.6054 225.909 72.5878 220.107 69.3024Z",
    fill: "url(#paint18_linear_334_2901)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M220.037 69.3025L106.724 3.87301C104.417 2.54485 102.32 2.33514 100.572 2.96427C100.363 3.03418 95.9589 5.6206 95.7491 5.69051C97.5666 4.85167 99.8036 4.99147 102.25 6.38954L215.563 71.889C221.365 75.2443 226.049 84.1919 226.049 91.9512V189.117C226.049 193.94 224.231 197.156 221.435 198.064C221.645 198.064 221.925 197.995 222.344 197.785C222.484 197.715 227.167 194.919 227.307 194.849C229.334 193.451 230.523 190.585 230.523 186.6V89.4347C230.523 81.6754 225.839 72.6579 220.037 69.3025Z",
    fill: "url(#paint19_linear_334_2901)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M219.967 69.3724L106.654 3.94284C104.347 2.61468 102.25 2.40497 100.503 3.0341C100.293 3.104 95.9589 5.62052 95.7491 5.69043C97.5666 4.85159 99.8036 4.99139 102.25 6.38946L215.563 71.8889C221.365 75.2442 226.049 84.1919 226.049 91.9511V189.117C226.049 193.94 224.231 197.156 221.435 198.064C221.645 198.064 221.925 197.995 222.344 197.785C222.484 197.715 227.098 194.989 227.167 194.919C229.195 193.521 230.383 190.655 230.383 186.67V89.5045C230.453 81.6753 225.769 72.7277 219.967 69.3724Z",
    fill: "url(#paint20_linear_334_2901)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M219.828 69.4423L106.584 4.01279C104.277 2.68463 102.18 2.47491 100.433 3.10404C100.223 3.17395 95.9589 5.62057 95.7491 5.76037C97.5666 4.92153 99.8036 5.06134 102.25 6.45941L215.563 71.9588C221.365 75.3142 226.049 84.2618 226.049 92.0211V189.187C226.049 194.01 224.231 197.226 221.435 198.134C221.645 198.134 221.925 198.064 222.344 197.855C222.484 197.785 226.958 195.129 227.098 195.059C229.125 193.661 230.313 190.795 230.313 186.81V89.6444C230.383 81.7453 225.63 72.7977 219.828 69.4423Z",
    fill: "url(#paint21_linear_334_2901)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M219.758 69.5122L106.444 4.01279C104.138 2.68463 102.04 2.47491 100.293 3.10404C100.083 3.17395 95.8889 5.55066 95.6792 5.69047C97.4967 4.85163 99.7336 4.99144 102.18 6.3895L215.494 71.8889C221.296 75.2443 225.979 84.1919 225.979 91.9512V189.117C225.979 193.94 224.162 197.156 221.365 198.064C221.575 198.064 221.855 197.995 222.274 197.785C222.414 197.715 226.818 195.129 226.958 194.989C228.985 193.591 230.173 190.725 230.173 186.74V89.5745C230.243 81.8152 225.56 72.8676 219.758 69.5122Z",
    fill: "url(#paint22_linear_334_2901)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M219.688 69.582L106.374 4.08261C104.068 2.75445 101.971 2.54474 100.223 3.17387C100.013 3.24377 95.9589 5.55059 95.7491 5.69039C97.5666 4.85155 99.8036 4.99136 102.25 6.38943L215.563 71.8888C221.365 75.2442 226.049 84.1918 226.049 91.9511V189.117C226.049 193.94 224.231 197.156 221.435 198.064C221.645 198.064 221.925 197.994 222.344 197.785C222.484 197.715 226.818 195.128 226.958 195.059C228.985 193.66 230.173 190.794 230.173 186.81V89.6443C230.173 81.885 225.49 72.9374 219.688 69.582Z",
    fill: "url(#paint23_linear_334_2901)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M219.618 69.652L106.305 4.15256C103.998 2.82439 101.901 2.61468 100.153 3.24382C99.9434 3.31372 95.9589 5.55063 95.7491 5.69043C97.5666 4.85159 99.8036 4.9914 102.25 6.38947L215.563 71.8889C221.365 75.2442 226.049 84.1919 226.049 91.9511V189.117C226.049 193.94 224.231 197.156 221.435 198.064C221.645 198.064 221.925 197.995 222.344 197.785C222.484 197.715 226.678 195.198 226.818 195.128C228.845 193.73 230.033 190.864 230.033 186.88V89.7142C230.103 81.955 225.42 72.9374 219.618 69.652Z",
    fill: "url(#paint24_linear_334_2901)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M219.478 69.652L106.235 4.2225C103.928 2.89434 101.831 2.68463 100.083 3.31376C99.8735 3.38366 95.9589 5.62057 95.7491 5.69048C97.5666 4.85164 99.8036 4.99144 102.25 6.38951L215.563 71.8889C221.365 75.2443 226.049 84.1919 226.049 91.9512V189.117C226.049 193.94 224.231 197.156 221.435 198.064C221.645 198.064 221.925 197.995 222.344 197.785C222.484 197.715 226.608 195.268 226.748 195.198C228.775 193.8 229.964 190.934 229.964 186.95V89.7143C229.964 82.0249 225.28 73.0074 219.478 69.652Z",
    fill: "url(#paint25_linear_334_2901)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M219.408 69.7218L106.095 4.29233C103.788 2.96417 101.691 2.75445 99.9433 3.38358C99.7336 3.45349 95.8889 5.62049 95.6792 5.6904C97.4967 4.85156 99.7336 4.99136 102.18 6.38943L215.494 71.8889C221.296 75.2442 225.979 84.1918 225.979 91.9511V189.117C225.979 193.94 224.162 197.156 221.365 198.064C221.575 198.064 221.855 197.994 222.274 197.785C222.414 197.715 226.468 195.338 226.608 195.268C228.635 193.87 229.824 191.004 229.824 187.02V89.854C229.894 82.0248 225.21 73.0772 219.408 69.7218Z",
    fill: "url(#paint26_linear_334_2901)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M219.338 69.7918L106.025 4.36228C103.718 3.03411 101.621 2.8244 99.8734 3.45353C99.6637 3.52343 95.9589 5.62054 95.7491 5.76034C97.5666 4.9215 99.8036 5.06131 102.25 6.45938L215.563 71.9588C221.365 75.3142 226.049 84.2618 226.049 92.0211V189.187C226.049 194.01 224.231 197.226 221.435 198.134C221.645 198.134 221.925 198.064 222.344 197.855C222.484 197.785 226.468 195.478 226.538 195.408C228.565 194.01 229.754 191.144 229.754 187.16V89.9939C229.824 82.0948 225.14 73.1472 219.338 69.7918Z",
    fill: "url(#paint27_linear_334_2901)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M219.268 69.8617L105.955 4.36228C103.648 3.03411 101.551 2.8244 99.8036 3.45353C99.5938 3.52343 95.9589 5.55063 95.7491 5.69044C97.5666 4.8516 99.8036 4.99141 102.25 6.38947L215.563 71.8889C221.365 75.2443 226.049 84.1919 226.049 91.9512V189.117C226.049 193.94 224.231 197.156 221.435 198.064C221.645 198.064 221.925 197.995 222.344 197.785C222.484 197.715 226.329 195.478 226.468 195.338C228.496 193.94 229.684 191.074 229.684 187.09V89.924C229.754 82.1647 225.07 73.2171 219.268 69.8617Z",
    fill: "url(#paint28_linear_334_2901)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M219.129 69.9315L105.885 4.4321C103.578 3.10394 101.481 2.89422 99.7336 3.52335C99.5239 3.59326 95.9589 5.55056 95.7491 5.69036C97.5666 4.85152 99.8036 4.99133 102.25 6.3894L215.563 71.8888C221.365 75.2442 226.049 84.1918 226.049 91.9511V189.117C226.049 193.94 224.231 197.156 221.435 198.064C221.645 198.064 221.925 197.994 222.344 197.785C222.484 197.715 226.259 195.478 226.398 195.408C228.426 194.01 229.614 191.144 229.614 187.159V89.9938C229.614 82.2345 224.931 73.2869 219.129 69.9315Z",
    fill: "url(#paint29_linear_334_2901)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M219.059 70.0015L105.745 4.50204C103.438 3.17388 101.341 2.96417 99.5938 3.5933C99.3841 3.66321 95.8889 5.5506 95.6792 5.6904C97.4967 4.85156 99.7336 4.99137 102.18 6.38944L215.494 71.8889C221.296 75.2442 225.979 84.1918 225.979 91.9511V189.117C225.979 193.94 224.162 197.156 221.365 198.064C221.575 198.064 221.855 197.994 222.274 197.785C222.414 197.715 226.119 195.548 226.259 195.478C228.286 194.08 229.474 191.214 229.474 187.229V90.0637C229.544 82.3045 224.861 73.2869 219.059 70.0015Z",
    fill: "url(#paint30_linear_334_2901)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M218.989 70.0015L105.675 4.57199C103.369 3.24383 101.272 3.03412 99.5239 3.66325C99.3142 3.73315 95.9589 5.62054 95.7491 5.69045C97.5666 4.85161 99.8036 4.99141 102.25 6.38948L215.563 71.8889C221.365 75.2443 226.049 84.1919 226.049 91.9512V189.117C226.049 193.94 224.231 197.156 221.435 198.064C221.645 198.064 221.925 197.995 222.344 197.785C222.484 197.715 226.119 195.618 226.189 195.548C228.216 194.15 229.404 191.284 229.404 187.299V90.1337C229.474 82.3744 224.791 73.3569 218.989 70.0015Z",
    fill: "url(#paint31_linear_334_2901)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M218.919 70.0715L105.606 4.64194C103.299 3.31378 101.202 3.10406 99.454 3.73319C99.2443 3.8031 95.9589 5.62059 95.7491 5.69049C97.5666 4.85165 99.8036 4.99146 102.25 6.38952L215.563 71.8889C221.365 75.2443 226.049 84.1919 226.049 91.9512V189.117C226.049 193.94 224.231 197.156 221.435 198.064C221.645 198.064 221.925 197.995 222.344 197.785C222.484 197.715 225.979 195.688 226.119 195.618C228.146 194.22 229.334 191.354 229.334 187.369V90.2036C229.404 82.3744 224.651 73.4268 218.919 70.0715Z",
    fill: "url(#paint32_linear_334_2901)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M218.779 70.1413L105.466 4.71176C103.159 3.3836 101.062 3.17389 99.3142 3.80302C99.1045 3.87292 95.8889 5.62051 95.6792 5.76031C97.4967 4.92147 99.7336 5.06128 102.18 6.45935L215.494 71.9588C221.296 75.3141 225.979 84.2618 225.979 92.021V189.187C225.979 194.01 224.162 197.226 221.365 198.134C221.575 198.134 221.855 198.064 222.274 197.855C222.414 197.785 225.839 195.828 225.979 195.758C228.006 194.36 229.195 191.493 229.195 187.509V90.3433C229.264 82.4443 224.581 73.4966 218.779 70.1413Z",
    fill: "url(#paint33_linear_334_2901)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M218.709 70.2112L105.396 4.71176C103.089 3.3836 100.992 3.17389 99.2443 3.80302C99.0346 3.87292 95.9589 5.5506 95.7491 5.69041C97.5666 4.85157 99.8036 4.99138 102.25 6.38944L215.563 71.8889C221.365 75.2442 226.049 84.1919 226.049 91.9511V189.117C226.049 193.94 224.231 197.156 221.435 198.064C221.645 198.064 221.925 197.995 222.344 197.785C222.484 197.715 225.839 195.828 225.979 195.688C228.006 194.29 229.195 191.424 229.195 187.439V90.2734C229.195 82.5142 224.511 73.5666 218.709 70.2112Z",
    fill: "url(#paint34_linear_334_2901)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M218.639 70.2811L105.326 4.78171C103.019 3.45355 100.922 3.24383 99.1744 3.87296C98.9647 3.94287 95.9589 5.55065 95.7491 5.69045C97.5666 4.85161 99.8036 4.99142 102.25 6.38949L215.563 71.8889C221.365 75.2443 226.049 84.1919 226.049 91.9512V189.117C226.049 193.94 224.231 197.156 221.435 198.064C221.645 198.064 221.925 197.995 222.344 197.785C222.484 197.715 225.769 195.828 225.839 195.758C227.866 194.36 229.055 191.494 229.055 187.509V90.3434C229.125 82.5841 224.441 73.6365 218.639 70.2811Z",
    fill: "url(#paint35_linear_334_2901)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M218.569 70.351L105.256 4.85153C102.949 3.52337 100.852 3.31366 99.1045 3.94279C98.8948 4.01269 95.9589 5.55057 95.7491 5.69037C97.5666 4.85153 99.8036 4.99134 102.25 6.38941L215.563 71.8888C221.365 75.2442 226.049 84.1918 226.049 91.9511V189.117C226.049 193.94 224.231 197.156 221.435 198.064C221.645 198.064 221.925 197.994 222.344 197.785C222.484 197.715 225.63 195.897 225.769 195.827C227.797 194.429 228.985 191.563 228.985 187.579V90.4132C229.055 82.6539 224.301 73.6364 218.569 70.351Z",
    fill: "url(#paint36_linear_334_2901)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M216.053 71.6792L102.739 6.17976C100.363 4.78169 98.1958 4.64189 96.4482 5.34092C97.9162 5.13121 99.6637 5.48072 101.481 6.52927L214.795 72.0287C220.597 75.3841 225.28 84.3317 225.28 92.091V189.257C225.28 193.8 223.672 196.876 221.086 197.995C224.301 197.505 226.538 194.15 226.538 188.907V91.7414C226.538 83.9822 221.855 74.9646 216.053 71.6792Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M185.575 170.872H184.806V172.06H185.575V170.872Z",
    fill: "#5277F7"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M185.225 168.845C185.016 168.845 184.806 168.705 184.806 168.425V166.049C184.806 165.839 184.946 165.629 185.225 165.629C185.435 165.629 185.645 165.769 185.645 166.049V168.425C185.575 168.705 185.435 168.845 185.225 168.845ZM185.225 164.091C185.016 164.091 184.806 163.951 184.806 163.672V161.295C184.806 161.085 184.946 160.876 185.225 160.876C185.435 160.876 185.645 161.016 185.645 161.295V163.672C185.575 163.882 185.435 164.091 185.225 164.091ZM185.225 159.268C185.016 159.268 184.806 159.128 184.806 158.849V156.472C184.806 156.262 184.946 156.052 185.225 156.052C185.435 156.052 185.645 156.192 185.645 156.472V158.849C185.575 159.128 185.435 159.268 185.225 159.268ZM185.225 154.515C185.016 154.515 184.806 154.375 184.806 154.095V151.718C184.806 151.509 184.946 151.299 185.225 151.299C185.435 151.299 185.645 151.439 185.645 151.718V154.095C185.575 154.305 185.435 154.515 185.225 154.515ZM185.225 149.691C185.016 149.691 184.806 149.551 184.806 149.272V146.895C184.806 146.685 184.946 146.476 185.225 146.476C185.435 146.476 185.645 146.615 185.645 146.895V149.272C185.575 149.482 185.435 149.691 185.225 149.691ZM185.225 144.868C185.016 144.868 184.806 144.728 184.806 144.448V142.142C184.806 141.932 184.946 141.722 185.225 141.722C185.435 141.722 185.645 141.862 185.645 142.142V144.518C185.575 144.728 185.435 144.868 185.225 144.868ZM185.225 140.114C185.016 140.114 184.806 139.975 184.806 139.695V137.318C184.806 137.109 184.946 136.899 185.225 136.899C185.435 136.899 185.645 137.039 185.645 137.318V139.695C185.575 139.905 185.435 140.114 185.225 140.114ZM185.225 135.291C185.016 135.291 184.806 135.151 184.806 134.872V132.495C184.806 132.285 184.946 132.076 185.225 132.076C185.435 132.076 185.645 132.215 185.645 132.495V134.872C185.575 135.151 185.435 135.291 185.225 135.291ZM185.225 130.538C185.016 130.538 184.806 130.398 184.806 130.118V127.742C184.806 127.532 184.946 127.322 185.225 127.322C185.435 127.322 185.645 127.462 185.645 127.742V130.118C185.575 130.328 185.435 130.538 185.225 130.538Z",
    fill: "#5277F7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M185.575 124.177H184.806V125.365H185.575V124.177Z",
    fill: "#5277F7"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M162.786 156.402H162.017V157.59H162.786V156.402Z",
    fill: "#5277F7"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M162.786 154.025H162.017V151.649H162.786V154.025ZM162.367 149.621C162.157 149.621 161.948 149.482 161.948 149.202V146.825C161.948 146.616 162.087 146.406 162.367 146.406C162.577 146.406 162.786 146.546 162.786 146.825V149.202C162.786 149.482 162.577 149.621 162.367 149.621ZM162.367 144.868C162.157 144.868 161.948 144.728 161.948 144.449V142.072C161.948 141.862 162.087 141.652 162.367 141.652C162.577 141.652 162.786 141.792 162.786 142.072V144.449C162.786 144.658 162.577 144.868 162.367 144.868ZM162.367 140.045C162.157 140.045 161.948 139.905 161.948 139.625V137.248C161.948 137.039 162.087 136.829 162.367 136.829C162.577 136.829 162.786 136.969 162.786 137.248V139.625C162.786 139.905 162.577 140.045 162.367 140.045ZM162.367 135.291C162.157 135.291 161.948 135.151 161.948 134.872V132.495C161.948 132.285 162.087 132.076 162.367 132.076C162.577 132.076 162.786 132.215 162.786 132.495V134.872C162.786 135.081 162.577 135.291 162.367 135.291ZM162.367 130.468C162.157 130.468 161.948 130.328 161.948 130.048V127.672C161.948 127.462 162.087 127.252 162.367 127.252C162.577 127.252 162.786 127.392 162.786 127.672V130.048C162.786 130.328 162.577 130.468 162.367 130.468Z",
    fill: "#5277F7"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M162.786 124.177H162.017V125.365H162.786V124.177Z",
    fill: "#5277F7"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M133.427 139.625H132.658V140.813H133.427V139.625Z",
    fill: "#5277F7"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M133.008 137.668C132.798 137.668 132.588 137.528 132.588 137.248V134.872C132.588 134.662 132.728 134.452 133.008 134.452C133.217 134.452 133.427 134.592 133.427 134.872V137.248C133.427 137.458 133.217 137.668 133.008 137.668ZM133.008 132.845C132.798 132.845 132.588 132.705 132.588 132.425V130.048C132.588 129.839 132.728 129.629 133.008 129.629C133.217 129.629 133.427 129.769 133.427 130.048V132.425C133.427 132.705 133.217 132.845 133.008 132.845ZM133.008 128.091C132.798 128.091 132.588 127.951 132.588 127.672V125.295C132.588 125.085 132.728 124.876 133.008 124.876C133.217 124.876 133.427 125.015 133.427 125.295V127.672C133.427 127.881 133.217 128.091 133.008 128.091ZM133.008 123.268C132.798 123.268 132.588 123.128 132.588 122.848V120.472C132.588 120.262 132.728 120.052 133.008 120.052C133.217 120.052 133.427 120.192 133.427 120.472V122.848C133.427 123.128 133.217 123.268 133.008 123.268ZM133.008 118.514C132.798 118.514 132.588 118.375 132.588 118.095V115.718C132.588 115.509 132.728 115.299 133.008 115.299C133.217 115.299 133.427 115.439 133.427 115.718V118.095C133.427 118.305 133.217 118.514 133.008 118.514ZM133.008 113.691C132.798 113.691 132.588 113.551 132.588 113.272V110.895C132.588 110.685 132.728 110.475 133.008 110.475C133.217 110.475 133.427 110.615 133.427 110.895V113.272C133.427 113.551 133.217 113.691 133.008 113.691Z",
    fill: "#5277F7"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M133.427 107.4H132.658V108.588H133.427V107.4Z",
    fill: "#5277F7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M218.639 193.591L103.508 127.043C98.6851 123.967 96.4482 120.332 96.4482 114.111L133.008 107.959L162.717 125.295L176.208 114.111L185.086 124.596L221.925 94.3279V191.983C221.925 193.591 220.177 194.569 218.849 193.8C218.779 193.661 218.709 193.661 218.639 193.591Z",
    fill: "url(#paint37_linear_334_2901)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M220.736 94.4677L220.666 94.3279L185.994 122.918C185.645 122.499 185.295 122.149 184.876 121.87C184.317 121.52 183.757 121.45 183.338 121.66L178.585 116.138C178.585 116.068 178.585 115.998 178.585 115.858C178.585 114.39 177.536 112.573 176.278 111.874C175.02 111.105 173.971 111.734 173.971 113.202C173.971 113.761 174.111 114.39 174.39 114.949L163.905 123.198C163.485 122.639 163.066 122.149 162.507 121.87C161.388 121.241 160.41 121.59 160.2 122.709L135.035 108.169C134.685 106.98 133.846 105.862 132.868 105.303C131.61 104.534 130.561 105.163 130.561 106.631C130.561 106.91 130.631 107.26 130.701 107.54L97.0074 113.272C97.0773 113.761 97.0773 114.18 97.2171 114.67L131.26 108.868C131.679 109.637 132.239 110.266 132.938 110.615C134.056 111.244 134.965 110.895 135.244 109.846L160.48 124.456C160.829 125.575 161.668 126.693 162.577 127.182C163.835 127.951 164.884 127.322 164.884 125.854C164.884 125.365 164.744 124.946 164.604 124.456L175.159 116.138C175.509 116.557 175.928 116.977 176.348 117.186C176.977 117.536 177.466 117.606 177.886 117.396L182.639 122.918C182.639 122.988 182.639 123.128 182.639 123.198C182.639 124.666 183.688 126.483 184.946 127.182C186.204 127.951 187.253 127.322 187.253 125.854C187.253 125.295 187.113 124.666 186.833 124.037L220.806 96.0056V94.4677H220.736Z",
    fill: "url(#paint38_linear_334_2901)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.02381,
    d: "M38.6381 194.639L9.97775 178.002C8.64958 177.233 8.85929 175.905 10.3273 175.066L13.8923 173.039C15.4302 172.13 17.737 172.06 18.9953 172.829L47.6556 189.466C48.9838 190.235 48.7741 191.563 47.3061 192.402L43.7411 194.429C42.2731 195.268 39.9663 195.408 38.6381 194.639Z",
    fill: "#A8AEDC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.047619,
    d: "M38.0789 194.15L10.1175 177.932C8.85926 177.163 8.99907 175.905 10.467 174.996L13.8923 173.039C15.3603 172.2 17.6671 172.06 18.9253 172.829L46.8867 189.047C48.1449 189.816 48.0051 191.074 46.5372 191.983L43.1119 193.94C41.6439 194.849 39.407 194.919 38.0789 194.15Z",
    fill: "#A1A7D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.071429,
    d: "M37.5197 193.73L10.2574 177.932C8.9991 177.233 9.1389 175.905 10.6069 175.066L13.8923 173.179C15.3603 172.34 17.5972 172.27 18.8555 172.969L46.1178 188.767C47.376 189.466 47.2362 190.795 45.7682 191.633L42.4828 193.521C41.0148 194.36 38.7779 194.429 37.5197 193.73Z",
    fill: "#999FC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.095238,
    d: "M36.9604 193.241L10.3971 177.862C9.13887 177.163 9.27867 175.905 10.7466 175.066L13.9622 173.249C15.4302 172.41 17.5972 172.34 18.7855 173.039L45.3488 188.418C46.6071 189.117 46.4672 190.375 44.9993 191.214L41.7837 193.031C40.3158 193.87 38.1488 193.94 36.9604 193.241Z",
    fill: "#9298BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.119,
    d: "M36.3312 192.752L10.5369 177.792C9.34856 177.093 9.48837 175.835 10.8864 175.066L13.9622 173.319C15.3602 172.48 17.4574 172.41 18.7156 173.109L44.5099 188.068C45.6983 188.767 45.5585 190.026 44.1604 190.794L41.0847 192.542C39.6866 193.381 37.5895 193.451 36.3312 192.752Z",
    fill: "#8B90B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M35.772 192.332L10.6767 177.792C9.48839 177.093 9.6282 175.905 11.0263 175.136L14.0321 173.389C15.4302 172.62 17.4574 172.48 18.7156 173.179L43.8109 187.719C44.9993 188.418 44.8595 189.606 43.4614 190.375L40.4556 192.123C39.0575 192.892 36.9604 193.031 35.772 192.332Z",
    fill: "#8489AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1667,
    d: "M35.2128 191.843L10.8166 177.723C9.62822 177.023 9.76803 175.905 11.1661 175.066L14.0321 173.389C15.3603 172.62 17.3875 172.55 18.5759 173.179L42.9721 187.299C44.1605 187.998 44.0207 189.117 42.6226 189.956L39.7566 191.633C38.4284 192.472 36.3313 192.542 35.2128 191.843Z",
    fill: "#7C81A3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M34.6536 191.354L10.8865 177.653C9.76802 177.024 9.90782 175.835 11.236 175.066L13.9622 173.458C15.2904 172.69 17.2477 172.62 18.436 173.249L42.1333 186.95C43.2517 187.579 43.1119 188.767 41.7838 189.536L39.0575 191.144C37.7293 191.983 35.7721 192.053 34.6536 191.354Z",
    fill: "#757A9A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2143,
    d: "M34.0245 190.934L11.0263 177.653C9.90782 177.023 10.0476 175.905 11.3059 175.136L13.9622 173.598C15.2205 172.829 17.1778 172.759 18.2962 173.389L41.2944 186.67C42.4129 187.299 42.2731 188.418 41.0148 189.187L38.3585 190.725C37.1002 191.493 35.1429 191.563 34.0245 190.934Z",
    fill: "#6E7290"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M33.4653 190.445L11.1661 177.583C10.0477 176.954 10.1875 175.835 11.4457 175.136L13.9622 173.668C15.2205 172.969 17.1079 172.829 18.2263 173.458L40.5255 186.321C41.644 186.95 41.5042 188.068 40.2459 188.767L37.7294 190.235C36.4711 191.004 34.5837 191.074 33.4653 190.445Z",
    fill: "#676B87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2619,
    d: "M32.906 190.026L11.3059 177.583C10.2573 176.954 10.3971 175.905 11.5855 175.206L14.0321 173.808C15.2904 173.109 17.1079 173.039 18.2263 173.668L39.8264 186.111C40.875 186.74 40.7352 187.789 39.5468 188.488L37.1002 189.886C35.8419 190.515 33.9546 190.585 32.906 190.026Z",
    fill: "#5F637D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M32.2769 189.536L11.3758 177.513C10.3273 176.884 10.4671 175.835 11.6554 175.136L13.9622 173.808C15.1506 173.109 16.9681 173.039 18.0166 173.668L38.9177 185.692C39.9663 186.321 39.8265 187.369 38.6381 188.068L36.3313 189.396C35.2129 190.026 33.3255 190.165 32.2769 189.536Z",
    fill: "#585C74"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3095,
    d: "M31.7177 189.047L11.5855 177.443C10.537 176.884 10.6768 175.835 11.8652 175.136L14.0322 173.878C15.2205 173.179 16.9681 173.109 18.0167 173.738L38.2187 185.342C39.2673 185.901 39.1275 186.95 37.9391 187.649L35.7721 188.907C34.5138 189.606 32.7662 189.676 31.7177 189.047Z",
    fill: "#51546A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M31.1584 188.627L11.7253 177.443C10.7467 176.884 10.8865 175.835 12.0049 175.206L14.102 174.018C15.2205 173.388 16.9681 173.249 18.0166 173.878L37.4497 185.062C38.4284 185.622 38.2886 186.67 37.1701 187.299L35.073 188.488C33.8847 189.117 32.1371 189.187 31.1584 188.627Z",
    fill: "#4A4D61"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3571,
    d: "M30.5993 188.138L11.8651 177.373C10.8865 176.814 11.0263 175.835 12.1448 175.206L14.1021 174.088C15.2205 173.458 16.8982 173.389 17.8768 173.948L36.6109 184.713C37.5896 185.272 37.4498 186.251 36.3313 186.88L34.374 187.998C33.2556 188.627 31.5779 188.697 30.5993 188.138Z",
    fill: "#424558"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M29.9701 187.649L11.935 177.303C10.9564 176.744 11.0962 175.835 12.2146 175.206L14.102 174.157C15.2205 173.528 16.8283 173.458 17.8069 174.018L35.842 184.363C36.8206 184.923 36.6808 185.831 35.5624 186.46L33.675 187.509C32.6264 188.138 30.9487 188.208 29.9701 187.649Z",
    fill: "#3B3E4E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4048,
    d: "M29.4109 187.229L12.0748 177.233C11.1661 176.674 11.236 175.765 12.3544 175.136L14.102 174.157C15.1506 173.528 16.7584 173.458 17.6671 174.018L35.0031 184.014C35.9119 184.573 35.842 185.482 34.7235 186.111L32.9759 187.09C31.9274 187.649 30.3196 187.719 29.4109 187.229Z",
    fill: "#343645"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M28.8517 186.74L12.2146 177.163C11.3059 176.674 11.4457 175.765 12.4943 175.136L14.102 174.227C15.1506 173.598 16.6885 173.598 17.5972 174.088L34.2342 183.664C35.1429 184.154 35.0031 185.062 33.9546 185.692L32.3468 186.6C31.2983 187.229 29.7604 187.229 28.8517 186.74Z",
    fill: "#2D2F3B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4524,
    d: "M28.2924 186.251L12.3544 177.093C11.5156 176.604 11.5855 175.695 12.5641 175.136L14.102 174.227C15.0807 173.668 16.6185 173.598 17.5273 174.088L33.4652 183.245C34.3041 183.734 34.2342 184.643 33.2555 185.202L31.7176 186.111C30.6691 186.74 29.1312 186.81 28.2924 186.251Z",
    fill: "#252732"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M27.6633 185.831L12.4942 177.093C11.6554 176.604 11.7253 175.765 12.704 175.206L14.102 174.367C15.0807 173.808 16.5486 173.738 17.3875 174.227L32.6264 182.965C33.4653 183.455 33.3953 184.293 32.4167 184.853L31.0186 185.692C30.04 186.251 28.572 186.321 27.6633 185.831Z",
    fill: "#1E2028"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.1041 185.342L12.5642 177.024C11.7253 176.534 11.8651 175.695 12.7739 175.136L14.102 174.367C15.0807 173.808 16.4788 173.738 17.3176 174.227L31.8575 182.546C32.6963 183.035 32.5565 183.874 31.6478 184.433L30.3196 185.202C29.4109 185.761 27.9429 185.831 27.1041 185.342Z",
    fill: "#17181F"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5974 174.996L57.3023 172.829L90.3666 145.427L86.5918 147.594L53.5974 174.996Z",
    fill: "#0CB073"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6458 181.707L24.1681 178.422L44.7197 163.532L39.1274 166.888L18.6458 181.707Z",
    fill: "#1F45CC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6168 154.794L43.3216 152.627L57.512 160.526L53.8071 162.693L39.6168 154.794Z",
    fill: "url(#paint39_linear_334_2901)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4985 135.361L78.2033 133.194L107.772 123.897L103.998 126.064L74.4985 135.361Z",
    fill: "#CAFF82"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9044 153.047L95.6792 150.88L107.772 123.897L103.998 126.064L91.9044 153.047Z",
    fill: "#51A245"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4985 135.361L79.8811 140.744L80.0908 140.883L53.8071 162.693L39.6167 154.794L9.76801 176.394L18.6457 181.707L39.1274 166.888L53.5974 174.996L86.6617 147.664L86.7316 147.734L91.9044 153.047L103.998 126.064L74.4985 135.361Z",
    fill: "url(#paint40_linear_334_2901)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M103.788 126.553L107.283 124.177L103.508 126.274L74.4985 135.361L75.0577 135.92L103.788 126.553Z",
    fill: "url(#paint41_radial_334_2901)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6167 155.493L53.8071 163.392L80.0908 141.652L79.8811 141.443L79.6713 141.233L53.8071 162.693L39.6167 154.794L9.76801 176.394L10.3272 176.744L39.6167 155.493Z",
    fill: "url(#paint42_radial_334_2901)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M170.686 108.518L99.5939 67.5548V3.80298L170.686 44.7663V108.518Z",
    fill: "#9098CC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M169.917 108.868L98.8249 67.8344V4.15247L169.917 45.1158V108.868Z",
    fill: "#AFB6E5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9434 67.2053V11.1428L168.728 50.8479V106.91L99.9434 67.2053Z",
    fill: "#F9FAFA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M163.206 42.5993L158.942 40.1527V43.5081L163.206 45.9547V42.5993Z",
    fill: "url(#paint43_linear_334_2901)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M158.522 40.1527L158.452 40.5721L158.383 40.1527H158.522Z",
    fill: "url(#paint44_linear_334_2901)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M160.899 39.9429L162.926 40.9914V41.1312L161.738 46.0944H161.179L159.151 45.0458L158.452 40.572L158.522 40.1526L160.899 39.9429Z",
    fill: "url(#paint45_linear_334_2901)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M161.738 46.0944L162.926 41.1312L163.695 45.8847L161.738 46.0944Z",
    fill: "url(#paint46_linear_334_2901)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M152.511 36.4477L148.247 34.0011V37.3565L152.511 39.8031V36.4477Z",
    fill: "url(#paint47_linear_334_2901)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M150.274 33.7914L150.693 34.0011L149.435 39.3836L148.526 38.8943L147.687 34.0011L150.274 33.7914Z",
    fill: "url(#paint48_linear_334_2901)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M150.693 34.0011L152.231 34.8399L153.07 39.7332L150.553 39.9429L149.435 39.3837L150.693 34.0011Z",
    fill: "url(#paint49_linear_334_2901)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M141.885 30.2963L137.551 27.8497L137.621 31.1352L141.885 33.6517V30.2963Z",
    fill: "url(#paint50_linear_334_2901)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M138.25 27.7797L137.551 30.8554L137.062 27.8496L138.25 27.7797Z",
    fill: "url(#paint51_linear_334_2901)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M139.579 27.6399L141.606 28.6884L142.025 31.4147L141.536 33.6516L139.858 33.7914L137.831 32.7428L137.551 30.8555L138.25 27.7797L139.579 27.6399Z",
    fill: "url(#paint52_linear_334_2901)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M141.536 33.6517L142.025 31.4148L142.375 33.5818L141.536 33.6517Z",
    fill: "url(#paint53_linear_334_2901)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M131.19 24.1447L126.926 21.6981V24.9836L131.19 27.5001V24.1447Z",
    fill: "url(#paint54_linear_334_2901)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M128.953 21.4884L130.281 22.1874L129.023 27.57L127.206 26.5913L126.367 21.6981L128.953 21.4884Z",
    fill: "url(#paint55_linear_334_2901)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M130.281 22.1875L130.911 22.537L131.749 27.4303L129.233 27.64L129.023 27.5701L130.281 22.1875Z",
    fill: "url(#paint56_linear_334_2901)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M120.495 17.9934L116.231 15.5468V18.8322L120.565 21.3487L120.495 17.9934Z",
    fill: "url(#paint57_linear_334_2901)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M118.048 15.3369L116.79 20.5797L116.51 20.4399L115.742 15.5466L118.048 15.3369Z",
    fill: "url(#paint58_linear_334_2901)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M118.258 15.3369L120.285 16.3855L121.054 21.2787L118.538 21.4884L116.79 20.5797L118.048 15.3369H118.258Z",
    fill: "url(#paint59_linear_334_2901)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M109.87 11.8418L105.606 9.39514V12.6806L109.87 15.1971V11.8418Z",
    fill: "url(#paint60_linear_334_2901)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M105.536 9.39514L105.256 10.5835L105.046 9.39514H105.536Z",
    fill: "url(#paint61_linear_334_2901)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M107.563 9.18542L109.59 10.234L109.73 11.1427L108.751 15.267L107.842 15.3369L105.885 14.2884L105.256 10.5835L105.536 9.39513L107.563 9.18542Z",
    fill: "url(#paint62_linear_334_2901)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M108.751 15.2671L109.73 11.1428L110.429 15.1273L108.751 15.2671Z",
    fill: "url(#paint63_linear_334_2901)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M169.218 31.3448C168.029 30.6458 166.561 30.7856 165.023 31.6244C162.157 33.3021 159.92 37.1468 159.92 40.4322C159.92 41.9002 160.34 43.0187 161.179 43.7876C161.738 44.2769 162.437 44.5565 163.206 44.6264V42.739C162.717 42.8089 162.717 42.739 162.437 42.4594C162.018 42.04 161.738 41.341 161.808 40.4322C161.808 37.8458 163.765 34.4904 166.002 33.2322C166.911 32.673 167.82 32.6031 168.379 32.8827C168.938 33.2322 169.288 34.0011 169.288 35.0497C169.288 36.238 168.868 37.6361 168.169 38.9643L169.777 39.873C170.686 38.2652 171.175 36.5875 171.175 35.1196C170.965 33.372 170.336 32.0438 169.218 31.3448Z",
    fill: "url(#paint64_linear_334_2901)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M158.522 25.1933C157.334 24.4943 155.866 24.6341 154.328 25.4729C151.462 27.0807 149.225 30.9953 149.225 34.2807C149.225 35.7487 149.645 36.8672 150.483 37.6361C151.043 38.1254 151.742 38.405 152.511 38.4749V36.5875C152.021 36.6575 152.021 36.5875 151.742 36.3079C151.322 35.8885 151.043 35.1895 151.113 34.2807C151.113 31.6943 153.07 28.339 155.307 27.0807C156.216 26.5215 157.124 26.4516 157.684 26.7312C158.243 27.0807 158.592 27.8496 158.592 28.8982C158.592 30.0865 158.173 31.4846 157.474 32.8128L159.082 33.7215C159.99 32.1137 160.48 30.4361 160.48 28.9681C160.34 27.2205 159.711 25.8224 158.522 25.1933Z",
    fill: "url(#paint65_linear_334_2901)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M147.827 18.9719C146.639 18.2728 145.171 18.4126 143.633 19.2515C140.767 20.8593 138.53 24.7738 138.53 28.0593C138.53 29.5273 138.949 30.6457 139.788 31.4147C140.348 31.904 141.047 32.1836 141.815 32.2535V30.3661C141.326 30.436 141.326 30.3661 141.047 30.0865C140.627 29.6671 140.348 28.968 140.417 28.0593C140.417 25.4729 142.375 22.1175 144.612 20.8593C145.52 20.3 146.429 20.2301 146.988 20.5097C147.548 20.8593 147.897 21.6282 147.897 22.6767C147.897 23.8651 147.478 25.2632 146.779 26.5913L148.386 27.5001C149.295 25.8923 149.784 24.2146 149.784 22.7466C149.645 20.9991 149.016 19.6709 147.827 18.9719Z",
    fill: "url(#paint66_linear_334_2901)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M137.132 12.8204C135.944 12.1213 134.476 12.2612 132.938 13.1C130.072 14.7777 127.835 18.6224 127.835 21.9078C127.835 23.3758 128.254 24.4942 129.093 25.2632C129.652 25.7525 130.351 26.0321 131.12 26.102V24.2146C130.631 24.2845 130.631 24.2146 130.351 23.935C129.932 23.5156 129.652 22.8166 129.722 21.9078C129.722 19.3214 131.679 15.966 133.916 14.7078C134.825 14.1485 135.734 14.0786 136.293 14.3582C136.852 14.7078 137.202 15.4767 137.202 16.5253C137.202 17.7136 136.782 19.1117 136.083 20.4398L137.691 21.3486C138.6 19.7408 139.089 18.0631 139.089 16.5952C138.949 14.8476 138.32 13.5194 137.132 12.8204Z",
    fill: "url(#paint67_linear_334_2901)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M126.507 6.66901C125.318 5.96998 123.85 6.10979 122.312 6.94863C119.446 8.62631 117.209 12.471 117.209 15.7564C117.209 17.2244 117.629 18.3429 118.468 19.1118C119.027 19.6011 119.726 19.8807 120.495 19.9506V18.0633C120.006 18.1332 120.006 18.0633 119.726 17.7836C119.307 17.3642 119.027 16.6652 119.097 15.7564C119.097 13.17 121.054 9.81466 123.291 8.5564C124.2 7.99718 125.109 7.92727 125.668 8.20689C126.227 8.5564 126.577 9.32534 126.577 10.3739C126.577 11.5622 126.157 12.9603 125.458 14.2885L127.066 15.1972C127.975 13.5894 128.464 11.9118 128.464 10.4438C128.254 8.62631 127.625 7.29814 126.507 6.66901Z",
    fill: "url(#paint68_linear_334_2901)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M115.811 0.447577C114.623 -0.251456 113.155 -0.111653 111.617 0.727187C108.751 2.40487 106.514 6.24955 106.514 9.53501C106.514 11.003 106.934 12.1214 107.773 12.8904C108.332 13.3797 109.031 13.6593 109.8 13.7292V11.8418C109.31 11.9117 109.31 11.8418 109.031 11.5622C108.611 11.1428 108.332 10.4438 108.402 9.53501C108.402 6.94859 110.359 3.59323 112.596 2.33497C113.505 1.77574 114.413 1.70584 114.973 1.98545C115.532 2.33497 115.881 3.1039 115.881 4.15245C115.881 5.34081 115.462 6.73887 114.763 8.06704L116.371 8.97578C117.279 7.36801 117.769 5.69032 117.769 4.22235C117.559 2.47477 116.93 1.14661 115.811 0.447577Z",
    fill: "url(#paint69_linear_334_2901)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M160.899 40.7118C160.899 37.6361 162.996 34.071 165.653 32.5331C167.12 31.6943 168.449 31.6244 169.567 32.2535C169.637 32.3234 169.707 32.3933 169.777 32.3933C169.567 32.1137 169.287 31.904 169.008 31.7642C167.889 31.1351 166.491 31.205 165.093 32.0438C162.437 33.5817 160.34 37.1468 160.34 40.2225C160.34 41.5507 160.759 42.6691 161.528 43.3682C161.598 43.4381 161.668 43.508 161.808 43.5779C161.179 42.8788 160.899 41.9002 160.899 40.7118Z",
    fill: "url(#paint70_radial_334_2901)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M170.056 35.7488C170.056 34.7002 169.707 33.8614 169.148 33.5817C169.148 33.5817 169.078 33.5817 169.078 33.5118C169.357 33.9313 169.497 34.4905 169.497 35.2594C169.497 36.4478 169.078 37.8458 168.379 39.174L169.008 39.5235C169.637 38.2653 169.987 36.9371 170.056 35.7488Z",
    fill: "url(#paint71_radial_334_2901)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 34.5603C150.134 31.4846 152.231 27.9195 154.887 26.3816C156.355 25.5428 157.684 25.4729 158.802 26.102C158.872 26.1719 158.942 26.2418 159.012 26.2418C158.802 25.9622 158.522 25.7525 158.243 25.6127C157.124 24.9836 155.726 25.0535 154.328 25.8923C151.672 27.4302 149.575 30.9953 149.575 34.071C149.575 35.3992 149.994 36.5176 150.763 37.2167C150.833 37.2866 150.903 37.3565 151.043 37.4264C150.414 36.7273 150.134 35.7487 150.134 34.5603Z",
    fill: "url(#paint72_radial_334_2901)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M159.221 29.5973C159.221 28.5487 158.872 27.7099 158.313 27.4303C158.313 27.4303 158.243 27.4303 158.243 27.3604C158.522 27.7798 158.662 28.339 158.662 29.1079C158.662 30.2963 158.243 31.6944 157.544 33.0225L158.173 33.372C158.872 32.0439 159.221 30.7157 159.221 29.5973Z",
    fill: "url(#paint73_radial_334_2901)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M139.509 28.4089C139.509 25.3331 141.606 21.768 144.262 20.2302C145.73 19.3913 147.058 19.3214 148.177 19.9505C148.247 20.0204 148.317 20.0904 148.386 20.0904C148.177 19.8107 147.897 19.601 147.617 19.4612C146.499 18.8321 145.101 18.902 143.703 19.7408C141.047 21.2787 138.949 24.8438 138.949 27.9195C138.949 29.2477 139.369 30.3661 140.138 31.0652C140.208 31.1351 140.278 31.205 140.417 31.2749C139.858 30.5759 139.509 29.5972 139.509 28.4089Z",
    fill: "url(#paint74_radial_334_2901)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M148.666 23.3758C148.666 22.3273 148.316 21.4884 147.757 21.2088C147.757 21.2088 147.687 21.2088 147.687 21.1389C147.967 21.5583 148.107 22.1176 148.107 22.8865C148.107 24.0749 147.687 25.4729 146.988 26.8011L147.617 27.1506C148.247 25.8923 148.666 24.5642 148.666 23.3758Z",
    fill: "url(#paint75_radial_334_2901)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M128.814 22.1874C128.814 19.1117 130.911 15.5466 133.567 14.0087C135.035 13.1699 136.363 13.1 137.482 13.7291C137.551 13.799 137.621 13.8689 137.691 13.8689C137.482 13.5893 137.202 13.3796 136.922 13.2398C135.804 12.6107 134.406 12.6806 133.008 13.5194C130.351 15.0573 128.254 18.6223 128.254 21.6981C128.254 23.0263 128.674 24.1447 129.443 24.8437C129.513 24.9136 129.582 24.9835 129.722 25.0535C129.093 24.3544 128.814 23.3758 128.814 22.1874Z",
    fill: "url(#paint76_radial_334_2901)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M137.971 17.1545C137.971 16.106 137.621 15.2671 137.062 14.9875C137.062 14.9875 136.992 14.9875 136.992 14.9176C137.272 15.337 137.412 15.8962 137.412 16.6652C137.412 17.8535 136.992 19.2516 136.293 20.5798L136.922 20.9293C137.551 19.671 137.971 18.3429 137.971 17.1545Z",
    fill: "url(#paint77_radial_334_2901)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M118.048 15.9661C118.048 12.8904 120.145 9.32529 122.802 7.78741C124.27 6.94857 125.598 6.87867 126.716 7.5078C126.786 7.5777 126.856 7.6476 126.926 7.6476C126.716 7.36799 126.437 7.15828 126.157 7.01847C125.039 6.38934 123.641 6.45925 122.243 7.29809C119.586 8.83596 117.489 12.401 117.489 15.4768C117.489 16.8049 117.909 17.9234 118.678 18.6224C118.747 18.6923 118.817 18.7622 118.957 18.8321C118.328 18.1331 118.048 17.1545 118.048 15.9661Z",
    fill: "url(#paint78_radial_334_2901)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M127.206 11.0029C127.206 9.95435 126.856 9.11551 126.297 8.8359C126.297 8.8359 126.227 8.83589 126.227 8.76599C126.507 9.18541 126.646 9.74464 126.646 10.5136C126.646 11.7019 126.227 13.1 125.528 14.4282L126.157 14.7777C126.786 13.5194 127.136 12.1913 127.206 11.0029Z",
    fill: "url(#paint79_radial_334_2901)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M107.423 9.81461C107.423 6.73886 109.52 3.17379 112.176 1.63592C113.644 0.79708 114.973 0.727176 116.091 1.35631C116.161 1.42621 116.231 1.49612 116.301 1.49612C116.091 1.2165 115.811 1.00679 115.532 0.866985C114.413 0.237854 113.015 0.307759 111.617 1.1466C108.961 2.68447 106.864 6.24954 106.864 9.32529C106.864 10.6535 107.283 11.7719 108.052 12.4709C108.122 12.5408 108.192 12.6107 108.332 12.6806C107.773 11.9816 107.423 11.003 107.423 9.81461Z",
    fill: "url(#paint80_radial_334_2901)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M111.128 20.5798L104.697 16.8749C104.277 16.5953 103.788 16.9448 103.788 17.504L103.858 18.972L112.386 23.8652L112.316 22.6769C112.386 21.838 111.897 20.9992 111.128 20.5798Z",
    fill: "#AFB6E5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M119.936 25.6129L113.505 21.908C113.085 21.6284 112.596 21.9779 112.596 22.5371L112.666 24.0051L121.194 28.8983L121.124 27.71C121.124 26.8711 120.635 26.0323 119.936 25.6129Z",
    fill: "#AFB6E5"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M128.674 30.6459L122.242 26.9411C121.823 26.6614 121.334 27.011 121.334 27.5702L121.404 29.0382L129.932 33.9314L129.862 32.743C129.862 31.9042 129.373 30.9955 128.674 30.6459Z",
    fill: "#AFB6E5"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M137.481 35.6091L131.05 31.9042C130.631 31.6246 130.142 31.9741 130.142 32.5333L130.212 34.0013L138.74 38.8945L138.67 37.7062C138.67 36.8673 138.18 36.0285 137.481 35.6091Z",
    fill: "#AFB6E5"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M146.219 40.642L139.788 36.9372C139.369 36.6575 138.88 37.0071 138.88 37.5663L138.949 39.0343L147.478 43.9275L147.408 42.7391C147.408 41.9003 146.918 41.0615 146.219 40.642Z",
    fill: "#AFB6E5"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M155.027 45.6751L148.596 41.9702C148.177 41.6906 147.687 42.0401 147.687 42.5994L147.757 44.0673L156.285 48.9606L156.216 47.7722C156.216 46.9334 155.726 46.0945 155.027 45.6751Z",
    fill: "#AFB6E5"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M163.765 50.7082L157.334 47.0033C156.915 46.7237 156.425 47.0732 156.425 47.6325L156.495 49.1004L165.023 53.9937L164.953 52.8053C164.953 51.9665 164.464 51.0577 163.765 50.7082Z",
    fill: "#AFB6E5"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M103.439 65.4577L165.163 100.689L165.233 72.8674L103.718 35.6788L103.439 65.4577Z",
    fill: "#E5E9FF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M130.072 62.1022L138.67 66.8557L138.74 57.7682L130.281 53.0847L130.072 62.1022Z",
    fill: "#AFB6E5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M165.513 101.318L103.159 65.5975L103.299 19.1118L165.583 54.8324V55.0421L165.513 101.318ZM103.858 65.1781L164.814 100.13L164.884 55.1819L103.998 20.3002L103.858 65.1781Z",
    fill: "#CED3F4"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M130.072 34.8401L165.233 55.0421L164.953 73.2869L129.932 53.2945L130.212 62.5917L103.508 47.0731L103.648 28.8284L130.072 43.8576V34.8401Z",
    fill: "#F00A9C"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M165.583 55.0421H164.884V100.759H165.583V55.0421Z",
    fill: "#CED3F4"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M156.635 95.7258L156.006 95.586L156.076 49.9391H156.775L156.705 95.1665L156.635 95.7258Z",
    fill: "#CED3F4"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M147.687 90.6229L147.198 90.4831L147.338 44.9061H148.037L147.897 90.2035L147.687 90.6229Z",
    fill: "#CED3F4"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M138.81 85.59L138.39 85.3103L138.53 39.8732H139.229L139.089 85.2404L138.81 85.59Z",
    fill: "#CED3F4"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M129.932 80.5567L129.582 80.2072L129.722 34.84H130.421L130.281 80.2771L129.932 80.5567Z",
    fill: "#CED3F4"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M120.984 75.5238L120.775 75.0345L120.914 29.807H121.613L121.474 75.3141L120.984 75.5238Z",
    fill: "#CED3F4"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M112.107 70.4907L111.967 69.8616L112.107 24.7739H112.806L112.666 70.3509L112.107 70.4907Z",
    fill: "#CED3F4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M103.928 19.741H103.229V65.4578H103.928V19.741Z",
    fill: "#CED3F4"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M165.384 100.439L103.705 65.0927L103.357 65.6991L165.036 101.046L165.384 100.439Z",
    fill: "#CED3F4"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M152.72 84.8209L103.439 56.4402L116.021 63.0111L165.303 91.3919L152.72 84.8209Z",
    fill: "#CED3F4"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M140.417 68.6733L103.578 47.213L128.394 60.9141L165.233 82.3744L140.417 68.6733Z",
    fill: "#CED3F4"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M128.114 52.4557L103.648 37.9158L140.767 58.8868L165.163 73.3568L128.114 52.4557Z",
    fill: "#CED3F4"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M115.811 36.2382L103.718 28.6886L153.07 56.7897L165.163 64.3393L115.811 36.2382Z",
    fill: "#CED3F4"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M165.397 54.6735L103.839 19.3962L103.491 20.0027L165.049 55.28L165.397 54.6735Z",
    fill: "#CED3F4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.090909,
    d: "M96.0287 99.5706C92.7433 97.6832 90.1569 99.2211 90.1569 102.926V141.093C90.1569 144.868 92.8132 149.412 96.0287 151.299L112.875 161.016C116.161 162.903 119.936 161.225 119.936 157.451V119.283C119.936 115.509 116.091 111.175 112.875 109.287L96.0287 99.5706Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1818,
    d: "M95.7491 99.8502C92.4637 97.9628 89.8773 99.5006 89.8773 103.206V141.163C89.8773 144.868 92.5336 149.482 95.7491 151.299L112.526 160.946C115.811 162.833 119.516 161.155 119.516 157.381V119.423C119.516 115.718 115.811 111.314 112.526 109.427L95.7491 99.8502Z",
    fill: "#A0A5D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2727,
    d: "M95.4695 100.06C92.184 98.1725 89.5976 99.7104 89.5976 103.415V141.093C89.5976 144.798 92.2539 149.342 95.4695 151.229L112.176 160.806C115.462 162.693 119.027 161.016 119.027 157.311V119.633C119.027 115.928 115.462 111.524 112.176 109.637L95.4695 100.06Z",
    fill: "#989CD3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3636,
    d: "M95.2598 100.27C92.0442 98.3823 89.3879 99.9202 89.3879 103.625V141.093C89.3879 144.798 92.0442 149.342 95.2598 151.229L111.827 160.736C115.042 162.623 118.538 160.946 118.538 157.241V119.773C118.538 116.068 115.042 111.664 111.827 109.777L95.2598 100.27Z",
    fill: "#9094CD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4545,
    d: "M94.9802 100.479C91.7647 98.5919 89.1083 100.13 89.1083 103.835V141.023C89.1083 144.728 91.7647 149.272 94.9802 151.159L111.477 160.666C114.693 162.553 118.048 160.946 118.048 157.171V119.982C118.048 116.277 114.693 111.804 111.477 109.986L94.9802 100.479Z",
    fill: "#898BC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5455,
    d: "M94.7006 100.689C91.485 98.8016 88.8287 100.34 88.8287 104.044V141.023C88.8287 144.728 91.485 149.272 94.7006 151.159L111.058 160.596C114.273 162.484 117.489 160.876 117.489 157.171V120.192C117.489 116.487 114.273 112.013 111.058 110.196L94.7006 100.689Z",
    fill: "#8183C1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6364,
    d: "M94.4908 100.969C91.2753 99.0813 88.619 100.619 88.619 104.324V141.023C88.619 144.728 91.2753 149.272 94.4908 151.159L110.778 160.526C113.994 162.414 117.14 160.806 117.14 157.101V120.402C117.14 116.697 114.064 112.223 110.778 110.406L94.4908 100.969Z",
    fill: "#7A7ABB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7273,
    d: "M94.2113 101.178C90.9957 99.291 88.3394 100.829 88.3394 104.534V140.953C88.3394 144.658 90.9258 149.202 94.2113 151.02L110.429 160.317C113.644 162.204 116.65 160.666 116.65 156.891V120.472C116.65 116.767 113.644 112.293 110.429 110.406L94.2113 101.178Z",
    fill: "#7272B5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8182,
    d: "M93.9316 101.388C90.7161 99.5007 88.0598 101.039 88.0598 104.743V140.953C88.0598 144.658 90.6462 149.202 93.9316 151.02L110.009 160.247C113.225 162.134 116.091 160.596 116.091 156.891V120.681C116.091 116.977 113.225 112.503 110.009 110.615L93.9316 101.388Z",
    fill: "#6A69AF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9091,
    d: "M93.7219 101.598C90.5063 99.7103 87.9199 101.248 87.9199 104.953V140.883C87.9199 144.588 90.5063 149.062 93.7219 150.949L109.73 160.177C112.945 162.064 115.672 160.526 115.672 156.821V120.891C115.672 117.186 112.945 112.712 109.73 110.825L93.7219 101.598Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4423 101.808C90.2268 99.9202 87.6403 101.458 87.6403 105.163V140.884C87.6403 144.588 90.2268 149.062 93.4423 150.95L109.38 160.107C112.596 161.994 115.182 160.456 115.182 156.752V121.031C115.182 117.326 112.596 112.852 109.38 110.965L93.4423 101.808Z",
    fill: "#5B58A3"
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4949C69.6053 94.1182 67.648 93.5589 68.8364 92.7201C68.9063 92.7201 73.5898 90.5531 73.6597 90.5531C74.918 90.0638 76.316 89.8541 77.9937 90.8327L109.241 108.868C112.736 110.895 115.602 116.347 115.602 121.031V204.286C115.602 206.802 114.763 208.55 113.505 209.389C113.435 209.459 108.122 211.905 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "#AFB6E5"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4949C69.6053 94.1182 67.648 93.5589 68.8364 92.7201C68.9063 92.7201 73.5199 90.623 73.5898 90.5531C74.8481 90.0638 76.2461 89.8541 77.9238 90.8327L109.171 108.868C112.666 110.895 115.532 116.347 115.532 121.031V204.286C115.532 206.802 114.693 208.55 113.435 209.389C113.365 209.459 108.122 211.835 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint81_linear_334_2901)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4949C69.6053 94.1182 67.648 93.559 68.8364 92.7201C68.9063 92.7201 73.45 90.623 73.5199 90.623C74.7782 90.1337 76.1762 89.924 77.8539 90.9026L109.101 108.938C112.596 110.965 115.462 116.417 115.462 121.101V204.356C115.462 206.872 114.623 208.62 113.365 209.459C113.295 209.529 108.192 211.905 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint82_linear_334_2901)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4949C69.6053 94.1182 67.648 93.559 68.8364 92.7201C68.9063 92.7201 73.3801 90.623 73.45 90.623C74.7083 90.1337 76.1063 89.924 77.784 90.9026L109.031 108.938C112.526 110.965 115.392 116.417 115.392 121.101V204.356C115.392 206.872 114.553 208.62 113.295 209.459C113.225 209.529 108.192 211.835 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint83_linear_334_2901)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4948C69.6053 94.1181 67.648 93.5589 68.8364 92.7201C68.9063 92.7201 73.3102 90.6929 73.3801 90.6929C74.6384 90.2035 76.0364 89.9938 77.7141 90.9725L108.961 109.008C112.456 111.035 115.322 116.487 115.322 121.171V204.426C115.322 206.942 114.483 208.69 113.225 209.529C113.155 209.598 108.192 211.905 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint84_linear_334_2901)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4948C69.6053 94.1181 67.648 93.5589 68.8364 92.7201C68.9063 92.7201 73.2403 90.6929 73.2403 90.6929C74.4986 90.2035 75.8966 89.9938 77.5743 90.9725L108.821 109.008C112.316 111.035 115.182 116.487 115.182 121.171V204.426C115.182 206.942 114.343 208.69 113.085 209.529C113.015 209.598 108.122 211.905 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint85_linear_334_2901)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4948C69.6053 94.1181 67.648 93.5589 68.8364 92.7201C68.9063 92.7201 73.1704 90.7628 73.1704 90.6929C74.4287 90.2035 75.8267 89.9938 77.5044 90.9725L108.751 109.008C112.246 111.035 115.112 116.487 115.112 121.171V204.426C115.112 206.942 114.274 208.69 113.015 209.529C112.945 209.598 108.122 211.835 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint86_linear_334_2901)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4949C69.6053 94.1182 67.648 93.5589 68.8364 92.7201C68.9063 92.7201 73.1005 90.7628 73.1005 90.7628C74.3587 90.2735 75.7568 90.0638 77.4345 91.0424L108.681 109.077C112.176 111.105 115.042 116.557 115.042 121.241V204.496C115.042 207.012 114.204 208.76 112.945 209.598C112.875 209.668 108.122 211.905 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint87_linear_334_2901)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4949C69.6053 94.1182 67.648 93.5589 68.8364 92.7201C68.9063 92.7201 72.9607 90.8327 73.0306 90.7628C74.2888 90.2735 75.6869 90.0638 77.3646 91.0424L108.611 109.077C112.107 111.105 114.973 116.557 114.973 121.241V204.496C114.973 207.012 114.134 208.76 112.875 209.598C112.806 209.668 108.122 211.835 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint88_linear_334_2901)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4949C69.6053 94.1182 67.648 93.559 68.8364 92.7201C68.9063 92.7201 72.8908 90.8328 72.9607 90.8328C74.2189 90.3434 75.617 90.1337 77.2947 91.1124L108.541 109.147C112.037 111.175 114.903 116.627 114.903 121.311V204.565C114.903 207.082 114.064 208.83 112.806 209.668C112.736 209.738 108.122 211.905 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint89_linear_334_2901)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4949C69.6053 94.1182 67.648 93.559 68.8364 92.7201C68.9063 92.7201 72.8209 90.8328 72.8908 90.8328C74.149 90.3434 75.5471 90.1337 77.2248 91.1124L108.472 109.147C111.967 111.175 114.833 116.627 114.833 121.311V204.565C114.833 207.082 113.994 208.83 112.736 209.668C112.666 209.738 108.122 211.905 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint90_linear_334_2901)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4949C69.6053 94.1182 67.648 93.559 68.8364 92.7201C68.9063 92.7201 72.751 90.9027 72.8209 90.8328C74.0791 90.3434 75.4772 90.1337 77.1549 91.1124L108.402 109.147C111.897 111.175 114.763 116.627 114.763 121.311V204.565C114.763 207.082 113.924 208.83 112.666 209.668C112.596 209.738 108.122 211.835 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint91_linear_334_2901)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4948C69.6053 94.1181 67.648 93.5589 68.8364 92.7201C68.9063 92.7201 72.6811 90.9026 72.751 90.9026C74.0092 90.4132 75.4073 90.2035 77.085 91.1822L108.332 109.217C111.827 111.244 114.693 116.697 114.693 121.38V204.635C114.693 207.152 113.854 208.899 112.596 209.738C112.526 209.808 108.192 211.905 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint92_linear_334_2901)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4948C69.6053 94.1181 67.648 93.5589 68.8364 92.7201C68.9063 92.7201 72.6112 90.9725 72.6811 90.9026C73.9393 90.4132 75.3374 90.2035 77.0151 91.1822L108.262 109.217C111.757 111.244 114.623 116.697 114.623 121.38V204.635C114.623 207.152 113.784 208.899 112.526 209.738C112.456 209.808 108.192 211.835 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint93_linear_334_2901)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4949C69.6053 94.1182 67.648 93.5589 68.8364 92.7201C68.9063 92.7201 72.5413 90.9725 72.6112 90.9725C73.8694 90.4832 75.2675 90.2735 76.9452 91.2521L108.192 109.287C111.687 111.314 114.553 116.767 114.553 121.45V204.705C114.553 207.222 113.714 208.969 112.456 209.808C112.386 209.878 108.192 211.905 108.122 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint94_linear_334_2901)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4949C69.6053 94.1182 67.648 93.5589 68.8364 92.7201C68.9063 92.7201 72.4714 90.9725 72.4714 90.9725C73.7296 90.4832 75.1277 90.2735 76.8054 91.2521L108.052 109.287C111.547 111.314 114.413 116.767 114.413 121.45V204.705C114.413 207.222 113.575 208.969 112.316 209.808C112.246 209.878 108.122 211.905 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint95_linear_334_2901)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4949C69.6053 94.1182 67.648 93.5589 68.8364 92.7201C68.9063 92.7201 72.4015 91.0424 72.4015 90.9725C73.6597 90.4832 75.0578 90.2735 76.7355 91.2521L107.982 109.287C111.477 111.314 114.343 116.767 114.343 121.45V204.705C114.343 207.222 113.505 208.969 112.246 209.808C112.176 209.878 108.122 211.835 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint96_linear_334_2901)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4948C69.6053 94.1181 67.648 93.5589 68.8364 92.72C68.9063 92.72 72.2616 91.0423 72.3315 91.0423C73.5898 90.553 74.9879 90.3433 76.6656 91.322L107.912 109.357C111.408 111.384 114.274 116.837 114.274 121.52V204.775C114.274 207.292 113.435 209.039 112.176 209.878C112.107 209.948 108.122 211.905 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint97_linear_334_2901)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4948C69.6053 94.1181 67.648 93.5589 68.8364 92.72C68.9063 92.72 72.1917 91.1122 72.2616 91.0423C73.5199 90.553 74.918 90.3433 76.5957 91.322L107.842 109.357C111.338 111.384 114.204 116.837 114.204 121.52V204.775C114.204 207.292 113.365 209.039 112.107 209.878C112.037 209.948 108.122 211.835 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint98_linear_334_2901)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.495C69.6053 94.1183 67.648 93.559 68.8364 92.7202C68.9063 92.7202 72.1218 91.1124 72.1918 91.1124C73.45 90.6231 74.8481 90.4134 76.5257 91.392L107.773 109.427C111.268 111.454 114.134 116.907 114.134 121.59V204.845C114.134 207.362 113.295 209.109 112.037 209.948C111.967 210.018 108.122 211.905 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint99_linear_334_2901)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.495C69.6053 94.1183 67.648 93.559 68.8364 92.7202C68.9063 92.7202 72.0519 91.1124 72.1218 91.1124C73.3801 90.6231 74.7782 90.4134 76.4558 91.392L107.703 109.427C111.198 111.454 114.064 116.907 114.064 121.59V204.845C114.064 207.362 113.225 209.109 111.967 209.948C111.897 210.018 108.122 211.835 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint100_linear_334_2901)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M107.213 209.948L75.9665 191.913C72.4714 189.886 69.6053 184.433 69.6053 179.75V96.4949C69.6053 94.1182 67.648 93.5589 68.8364 92.7201C68.9063 92.7201 71.982 91.1822 72.0519 91.1822C73.3102 90.6929 74.7083 90.4832 76.386 91.4618L107.633 109.497C111.128 111.524 113.994 116.977 113.994 121.66V204.915C113.994 207.431 113.155 209.179 111.897 210.018C111.827 210.088 108.122 211.905 108.052 211.905C106.864 212.255 108.751 210.857 107.213 209.948Z",
    fill: "url(#paint101_linear_334_2901)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M104.207 211.416L72.9606 193.381C69.4654 191.354 66.5994 185.901 66.5994 181.218V97.9628C66.5994 93.2793 69.4654 91.1123 72.9606 93.1395L104.207 111.175C107.703 113.202 110.569 118.654 110.569 123.338V206.593C110.569 211.276 107.772 213.443 104.207 211.416Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M106.724 211.556C106.025 211.556 105.256 211.346 104.487 210.857L73.2402 192.822C69.8849 190.864 67.1586 185.691 67.1586 181.148V97.9628C67.1586 94.9569 68.4169 92.9996 70.3742 92.9996C71.0732 92.9996 71.8421 93.2093 72.6111 93.6987L103.858 111.734C107.213 113.691 109.939 118.864 109.939 123.408V206.662C109.939 209.598 108.681 211.556 106.724 211.556Z",
    fill: "url(#paint102_linear_334_2901)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6965 182.196V99.291C68.6965 95.8658 70.7936 94.258 73.38 95.726L103.788 113.272C106.374 114.74 108.472 118.794 108.472 122.219V205.125C108.472 208.55 106.374 210.158 103.788 208.69L73.38 191.144C70.7936 189.676 68.6965 185.692 68.6965 182.196Z",
    fill: "#AFB6E5"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7295 96.7047C71.2829 95.3066 69.3256 96.4251 69.3256 99.2212V183.035C69.3256 185.831 71.2829 189.257 73.7295 190.655L103.438 207.781C105.885 209.179 107.842 208.061 107.842 205.265V121.45C107.842 118.654 105.885 115.229 103.438 113.831L73.7295 96.7047Z",
    fill: "#5D55EC"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7199 192.053H79.9509V193.241H80.7199V192.053Z",
    fill: "#5277F7"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7199 189.676H79.9509V187.299C79.9509 187.09 80.0907 186.88 80.3704 186.88C80.65 186.88 80.7898 187.02 80.7898 187.299V189.676H80.7199ZM80.3704 185.272C80.1606 185.272 79.9509 185.132 79.9509 184.853V182.476C79.9509 182.266 80.0907 182.057 80.3704 182.057C80.65 182.057 80.7898 182.196 80.7898 182.476V184.853C80.7199 185.132 80.5801 185.272 80.3704 185.272ZM80.3704 180.449C80.1606 180.449 79.9509 180.309 79.9509 180.029V177.653C79.9509 177.443 80.0907 177.233 80.3704 177.233C80.65 177.233 80.7898 177.373 80.7898 177.653V180.029C80.7199 180.309 80.5801 180.449 80.3704 180.449ZM80.3704 175.695C80.1606 175.695 79.9509 175.556 79.9509 175.276V172.899C79.9509 172.689 80.0907 172.48 80.3704 172.48C80.65 172.48 80.7898 172.62 80.7898 172.899V175.276C80.7199 175.486 80.5801 175.695 80.3704 175.695ZM80.3704 170.872C80.1606 170.872 79.9509 170.732 79.9509 170.453V168.076C79.9509 167.866 80.0907 167.656 80.3704 167.656C80.65 167.656 80.7898 167.796 80.7898 168.076V170.453C80.7199 170.732 80.5801 170.872 80.3704 170.872ZM80.3704 166.119C80.1606 166.119 79.9509 165.979 79.9509 165.699V163.322C79.9509 163.113 80.0907 162.903 80.3704 162.903C80.65 162.903 80.7898 163.043 80.7898 163.322V165.699C80.7199 165.909 80.5801 166.119 80.3704 166.119ZM80.3704 161.295C80.1606 161.295 79.9509 161.155 79.9509 160.876V158.499C79.9509 158.289 80.0907 158.08 80.3704 158.08C80.65 158.08 80.7898 158.219 80.7898 158.499V160.876C80.7199 161.155 80.5801 161.295 80.3704 161.295ZM80.3704 156.542C80.1606 156.542 79.9509 156.402 79.9509 156.122V153.746C79.9509 153.536 80.0907 153.326 80.3704 153.326C80.65 153.326 80.7898 153.466 80.7898 153.746V156.122C80.7199 156.332 80.5801 156.542 80.3704 156.542ZM80.3704 151.718C80.1606 151.718 79.9509 151.579 79.9509 151.299V148.922C79.9509 148.713 80.0907 148.503 80.3704 148.503C80.65 148.503 80.7898 148.643 80.7898 148.922V151.299C80.7199 151.579 80.5801 151.718 80.3704 151.718Z",
    fill: "#5277F7"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7199 145.357H79.9509V146.546H80.7199V145.357Z",
    fill: "#5277F7"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1841 198.064H91.4152V199.253H92.1841V198.064Z",
    fill: "#5277F7"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7646 196.037C91.5549 196.037 91.3452 195.897 91.3452 195.618V193.241C91.3452 193.031 91.485 192.822 91.7646 192.822C91.9743 192.822 92.184 192.962 92.184 193.241V195.618C92.184 195.828 91.9743 196.037 91.7646 196.037ZM91.7646 191.214C91.5549 191.214 91.3452 191.074 91.3452 190.794V188.418C91.3452 188.208 91.485 187.998 91.7646 187.998C91.9743 187.998 92.184 188.138 92.184 188.418V190.794C92.184 191.004 91.9743 191.214 91.7646 191.214ZM91.7646 186.391C91.5549 186.391 91.3452 186.251 91.3452 185.971V183.594C91.3452 183.385 91.485 183.175 91.7646 183.175C91.9743 183.175 92.184 183.315 92.184 183.594V185.971C92.184 186.181 91.9743 186.391 91.7646 186.391ZM91.7646 181.567C91.5549 181.567 91.3452 181.427 91.3452 181.148V178.771C91.3452 178.561 91.485 178.352 91.7646 178.352C91.9743 178.352 92.184 178.492 92.184 178.771V181.148C92.184 181.427 91.9743 181.567 91.7646 181.567ZM91.7646 176.744C91.5549 176.744 91.3452 176.604 91.3452 176.324V173.948C91.3452 173.738 91.485 173.528 91.7646 173.528C91.9743 173.528 92.184 173.668 92.184 173.948V176.324C92.184 176.604 91.9743 176.744 91.7646 176.744ZM91.7646 171.921C91.5549 171.921 91.3452 171.781 91.3452 171.501V169.124C91.3452 168.915 91.485 168.705 91.7646 168.705C91.9743 168.705 92.184 168.845 92.184 169.124V171.501C92.184 171.781 91.9743 171.921 91.7646 171.921ZM91.7646 167.097C91.5549 167.097 91.3452 166.957 91.3452 166.678V164.301C91.3452 164.091 91.485 163.882 91.7646 163.882C91.9743 163.882 92.184 164.022 92.184 164.301V166.678C92.184 166.957 91.9743 167.097 91.7646 167.097Z",
    fill: "#5277F7"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1841 160.736H91.4152V161.924H92.1841V160.736Z",
    fill: "#5277F7"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M113.015 150.67C112.107 151.159 111.407 150.67 111.407 149.412V142.631C111.407 141.443 112.107 140.045 113.015 139.555C113.924 139.066 114.623 139.555 114.623 140.814V147.594C114.623 148.783 113.924 150.181 113.015 150.67Z",
    fill: "url(#paint103_linear_334_2901)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0442 159.827L80.3703 146.336L69.3256 155.074V183.035C69.3256 185.831 71.2829 189.257 73.7295 190.655L103.438 207.781C105.885 209.179 107.842 208.061 107.842 205.264V146.685L92.0442 159.827Z",
    fill: "url(#paint104_linear_334_2901)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M107.842 145.847L93.0228 158.08C92.6733 157.66 92.3238 157.311 91.9044 157.031C91.3452 156.682 90.786 156.612 90.3665 156.822L82.7471 148.014C82.7471 147.944 82.7471 147.874 82.7471 147.734C82.7471 146.266 81.6985 144.449 80.4402 143.75C79.182 142.981 78.1334 143.61 78.1334 145.078C78.1334 145.637 78.2732 146.266 78.5529 146.825L69.3256 154.165V155.983L79.3218 148.084C79.6713 148.503 80.0907 148.922 80.5102 149.132C81.1393 149.482 81.6286 149.552 82.048 149.342L89.5976 158.15C89.5976 158.22 89.5976 158.359 89.5976 158.429C89.5976 159.897 90.6461 161.715 91.9044 162.414C93.1627 163.183 94.2112 162.554 94.2112 161.086C94.2112 160.526 94.0714 159.897 93.7918 159.268L107.842 147.664V145.847V145.847Z",
    fill: "url(#paint105_linear_334_2901)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M252.193 79.9978L248.488 82.2347L228.146 99.0814V99.9203L252.193 79.9978Z",
    fill: "#0CB073"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M236.325 69.9316L240.03 67.7646L269.599 58.5374L265.824 60.7044L236.325 69.9316Z",
    fill: "#00E9B1"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M253.731 87.6871L257.505 85.4501L269.599 58.5374L265.824 60.7044L253.731 87.6871Z",
    fill: "#068768"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M248.488 82.2346L248.628 82.3744L253.801 87.687L265.894 60.7043L236.395 69.9316L241.777 75.3141L241.987 75.5238L227.866 87.1977C228.076 88.456 228.216 89.7841 228.216 91.0424V99.0813L248.488 82.2346Z",
    fill: "#01B187"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M265.614 61.1238L269.109 58.817L265.335 60.8442L236.325 69.9316L236.884 70.4909L265.614 61.1238Z",
    fill: "url(#paint106_radial_334_2901)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M241.707 76.0133L241.498 75.8036L227.797 87.1978C227.866 87.4075 227.866 87.6173 227.936 87.827L241.917 76.223L241.707 76.0133Z",
    fill: "url(#paint107_radial_334_2901)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_334_2901",
    x1: 85.9039,
    y1: 172.595,
    x2: 243.799,
    y2: 172.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2623,
    stopColor: "#BAC1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4896,
    stopColor: "#C5CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7031,
    stopColor: "#D7DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8384,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8719,
    stopColor: "#D1D6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9192,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_334_2901",
    x1: 184.853,
    y1: 115.274,
    x2: 155.038,
    y2: 195.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3485,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8551,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(164.848 174.255) rotate(-0.790632) scale(62.4681 62.4563)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_334_2901",
    x1: 58.2299,
    y1: 210.373,
    x2: 124.237,
    y2: 210.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#BAC1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3433,
    stopColor: "#C5CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4931,
    stopColor: "#D7DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6717,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7346,
    stopColor: "#D1D6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8232,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_334_2901",
    x1: 102.865,
    y1: 176.068,
    x2: 85.0501,
    y2: 222.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3485,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8551,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.2302 212.303) scale(25.1267 25.1267)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_334_2901",
    x1: 61.026,
    y1: 203.684,
    x2: 127.033,
    y2: 203.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2899,
    stopColor: "#07CDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3434,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3988,
    stopColor: "#09C7CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4888,
    stopColor: "#21C9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6013,
    stopColor: "#48CBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#66CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9899,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_334_2901",
    x1: 58.2299,
    y1: 202.169,
    x2: 124.237,
    y2: 202.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#BAC1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3433,
    stopColor: "#C5CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4931,
    stopColor: "#D7DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6717,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7346,
    stopColor: "#D1D6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8232,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_334_2901",
    x1: 102.865,
    y1: 167.863,
    x2: 85.0501,
    y2: 213.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.020202,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6613,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.2302 204.099) scale(25.1267 25.1267)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_334_2901",
    x1: 55.6125,
    y1: 166.124,
    x2: 213.508,
    y2: 166.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2899,
    stopColor: "#07CDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3434,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3988,
    stopColor: "#09C7CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4888,
    stopColor: "#21C9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6013,
    stopColor: "#48CBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#66CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9899,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_334_2901",
    x1: 85.9039,
    y1: 164.308,
    x2: 243.799,
    y2: 164.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2623,
    stopColor: "#BAC1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4896,
    stopColor: "#C5CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7031,
    stopColor: "#D7DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8384,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8719,
    stopColor: "#D1D6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9192,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_334_2901",
    x1: 184.853,
    y1: 106.987,
    x2: 155.038,
    y2: 186.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.020202,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6613,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(164.848 165.968) rotate(-0.790632) scale(62.4681 62.4563)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_334_2901",
    x1: -2.68683,
    y1: 66.2569,
    x2: 292.776,
    y2: 131.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3485,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8551,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_334_2901",
    x1: 133.864,
    y1: -14.318,
    x2: 237.852,
    y2: 194.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3BAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BAC0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3BAE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_334_2901",
    x1: 133.823,
    y1: -14.2832,
    x2: 237.805,
    y2: 194.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4BBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#B9BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BCC2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#B2B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#B2B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#B3B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BBE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_334_2901",
    x1: 133.782,
    y1: -14.2483,
    x2: 237.758,
    y2: 194.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BDC3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#B7BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5BCE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_334_2901",
    x1: 133.74,
    y1: -14.2137,
    x2: 237.711,
    y2: 194.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BCC1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BFC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#BAC0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7BDE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_334_2901",
    x1: 133.699,
    y1: -14.1787,
    x2: 237.664,
    y2: 194.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BDC3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C1C6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#BEC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8BFE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_334_2901",
    x1: 133.658,
    y1: -14.144,
    x2: 237.617,
    y2: 194.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BFC4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C2C8ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#C2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9C0EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_334_2901",
    x1: 133.616,
    y1: -14.1091,
    x2: 237.57,
    y2: 194.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAC1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C0C6ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C4C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#BEC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#C6CBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#B2B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#BAC1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_334_2901",
    x1: 133.575,
    y1: -14.0744,
    x2: 237.522,
    y2: 194.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C2C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C6CBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#C1C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#CACEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#B6BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_334_2901",
    x1: 133.533,
    y1: -14.0396,
    x2: 237.475,
    y2: 194.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C4C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#C3C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#C4C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#CDD2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6644,
    stopColor: "#B9C0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9836,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_334_2901",
    x1: 133.492,
    y1: -14.0048,
    x2: 237.428,
    y2: 194.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C5CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#C6CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#C6CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#D0D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#D1D5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#BDC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9797,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEC4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_334_2901",
    x1: 133.451,
    y1: -13.97,
    x2: 237.381,
    y2: 194.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C7CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#C8CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5228,
    stopColor: "#D3D7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#D5D9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6403,
    stopColor: "#C1C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9763,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_334_2901",
    x1: 133.409,
    y1: -13.9353,
    x2: 237.334,
    y2: 194.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#CCD1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#CBD1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#D5D9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#D9DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6316,
    stopColor: "#C5CAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9704,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C7ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_334_2901",
    x1: 133.368,
    y1: -13.9005,
    x2: 237.287,
    y2: 194.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CACFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#CED3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#CDD3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#D8DCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#DDE0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6245,
    stopColor: "#C9CEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9679,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_334_2901",
    x1: 133.327,
    y1: -13.8658,
    x2: 237.24,
    y2: 194.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D0D4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#D0D5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#D0D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    stopColor: "#DADEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#E1E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6182,
    stopColor: "#CDD1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9656,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C9EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_334_2901",
    x1: 133.285,
    y1: -13.8311,
    x2: 237.193,
    y2: 194.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D1D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#D2D7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    stopColor: "#DDE1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#E4E7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6142,
    stopColor: "#D0D5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_334_2901",
    x1: 133.244,
    y1: -13.7964,
    x2: 237.146,
    y2: 194.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CFD3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#D5DAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#D6DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4993,
    stopColor: "#E0E3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#E8EAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    stopColor: "#D4D8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9597,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_334_2901",
    x1: 133.203,
    y1: -13.7617,
    x2: 237.099,
    y2: 194.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D0D5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D5D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#D7DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#D8DDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    stopColor: "#E2E6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6051,
    stopColor: "#D8DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9581,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7CCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_334_2901",
    x1: 133.161,
    y1: -13.727,
    x2: 237.052,
    y2: 194.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D2D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D6DBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#DADEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#DBDFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4921,
    stopColor: "#E5E8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#F0F1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6013,
    stopColor: "#DCDFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9566,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8CDF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_334_2901",
    x1: 133.12,
    y1: -13.6925,
    x2: 237.004,
    y2: 194.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D8DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#DCE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4882,
    stopColor: "#E7EAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#F4F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#E0E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9551,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9CFF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_334_2901",
    x1: 133.078,
    y1: -13.6578,
    x2: 236.957,
    y2: 194.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D5D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#DADEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#DFE3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#E0E4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4882,
    stopColor: "#EAEDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#F7F8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5957,
    stopColor: "#E3E6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7185,
    stopColor: "#B1B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9526,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_334_2901",
    x1: 133.037,
    y1: -13.6233,
    x2: 236.91,
    y2: 194.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D6DBF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#DBDFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#E1E6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#E2E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    stopColor: "#ECEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#FBFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#E7EAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7101,
    stopColor: "#B5BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9514,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_334_2901",
    x1: 132.995,
    y1: -13.5888,
    x2: 236.863,
    y2: 194.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5905,
    stopColor: "#EBEDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7024,
    stopColor: "#B9BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9503,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_334_2901",
    x1: 171.935,
    y1: 83.1279,
    x2: 157.954,
    y2: 160.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#8982FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#9E98FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#6960FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3930C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_334_2901",
    x1: 214.371,
    y1: 98.156,
    x2: 49.6319,
    y2: 148.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1447,
    stopColor: "#90ED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#35D5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6263,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8217,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_334_2901",
    x1: 58.4909,
    y1: 167.516,
    x2: 35.4879,
    y2: 144.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1061,
    stopColor: "#84EFA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1358,
    stopColor: "#80F0AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4933,
    stopColor: "#51F8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7676,
    stopColor: "#34FDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9242,
    stopColor: "#29FFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_334_2901",
    x1: 116.297,
    y1: 136.91,
    x2: -24.7474,
    y2: 186.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1039,
    stopColor: "#90ED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322,
    stopColor: "#35D5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4444,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5976,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7374,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7789,
    stopColor: "#516FEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8464,
    stopColor: "#4E58D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9309,
    stopColor: "#4933AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.4448 114.466) scale(25.2428 25.2428)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.0712 166.182) scale(26.7663 26.7663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_334_2901",
    x1: 171.738,
    y1: 51.5348,
    x2: 78.3438,
    y2: 11.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_334_2901",
    x1: 171.942,
    y1: 51.0604,
    x2: 78.5576,
    y2: 10.6437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_334_2901",
    x1: 171.738,
    y1: 51.5347,
    x2: 78.3436,
    y2: 11.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_334_2901",
    x1: 171.893,
    y1: 51.177,
    x2: 78.4962,
    y2: 10.7568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_334_2901",
    x1: 170.99,
    y1: 53.2648,
    x2: 77.595,
    y2: 12.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_334_2901",
    x1: 170.921,
    y1: 53.4229,
    x2: 77.5265,
    y2: 13.0041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_334_2901",
    x1: 171.029,
    y1: 53.1719,
    x2: 77.6359,
    y2: 12.7537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_334_2901",
    x1: 170.241,
    y1: 54.9947,
    x2: 76.8472,
    y2: 14.5766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_334_2901",
    x1: 170.231,
    y1: 55.0144,
    x2: 76.8394,
    y2: 14.5966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_334_2901",
    x1: 170.241,
    y1: 54.9947,
    x2: 76.8468,
    y2: 14.5763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_334_2901",
    x1: 170.183,
    y1: 55.1308,
    x2: 76.7863,
    y2: 14.7106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_334_2901",
    x1: 169.492,
    y1: 56.725,
    x2: 76.0978,
    y2: 16.3062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_334_2901",
    x1: 169.465,
    y1: 56.7876,
    x2: 76.0707,
    y2: 16.3691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_334_2901",
    x1: 169.574,
    y1: 56.5371,
    x2: 76.1785,
    y2: 16.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_334_2901",
    x1: 168.743,
    y1: 58.4551,
    x2: 75.3492,
    y2: 18.0366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_334_2901",
    x1: 168.623,
    y1: 58.7367,
    x2: 75.227,
    y2: 18.3177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_334_2901",
    x1: 168.755,
    y1: 58.4289,
    x2: 75.3608,
    y2: 18.0103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_334_2901",
    x1: 167.995,
    y1: 60.1851,
    x2: 74.6005,
    y2: 19.7663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_334_2901",
    x1: 168.133,
    y1: 59.8602,
    x2: 74.7412,
    y2: 19.4441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_334_2901",
    x1: 167.994,
    y1: 60.1846,
    x2: 74.6007,
    y2: 19.7662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_334_2901",
    x1: 168.086,
    y1: 59.9761,
    x2: 74.691,
    y2: 19.5574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_334_2901",
    x1: 168.489,
    y1: 40.7352,
    x2: 155.583,
    y2: 28.3626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_334_2901",
    x1: 157.807,
    y1: 34.5562,
    x2: 144.901,
    y2: 22.1838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_334_2901",
    x1: 147.125,
    y1: 28.3772,
    x2: 134.219,
    y2: 16.0048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_334_2901",
    x1: 136.443,
    y1: 22.1982,
    x2: 123.537,
    y2: 9.82585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_334_2901",
    x1: 125.761,
    y1: 16.0194,
    x2: 112.855,
    y2: 3.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_334_2901",
    x1: 115.079,
    y1: 9.84038,
    x2: 102.173,
    y2: -2.53203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163.858 35.6016) rotate(0.206264) scale(5.47102)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.412 36.2786) rotate(0.206262) scale(3.02267 3.02264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(153.088 29.4286) rotate(0.206264) scale(5.47102 5.47102)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.642 30.1057) rotate(0.206262) scale(3.02267 3.02264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142.488 23.2563) rotate(0.206264) scale(5.47109)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.042 23.9333) rotate(0.206264) scale(3.02263 3.02264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.775 17.0267) rotate(0.206264) scale(5.47102)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(135.329 17.7038) rotate(0.206264) scale(3.02263 3.02264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.004 10.8538) rotate(0.206264) scale(5.47109)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.558 11.5307) rotate(0.206265) scale(3.02256 3.02257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.404 4.68145) rotate(0.206264) scale(5.47102)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_334_2901",
    x1: 73.2533,
    y1: 90.9262,
    x2: 112.093,
    y2: 210.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#B2B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#B3B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_334_2901",
    x1: 73.2153,
    y1: 90.9422,
    x2: 112.054,
    y2: 210.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#B7BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2B9E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_334_2901",
    x1: 73.1773,
    y1: 90.9581,
    x2: 112.015,
    y2: 210.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3BAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BAC0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3BAE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_334_2901",
    x1: 73.1393,
    y1: 90.9739,
    x2: 111.976,
    y2: 210.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5BBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BEC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5BBE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_334_2901",
    x1: 73.1013,
    y1: 90.9898,
    x2: 111.937,
    y2: 210.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6BDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6BDE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_334_2901",
    x1: 73.0633,
    y1: 91.0057,
    x2: 111.898,
    y2: 210.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8BEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BEC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C6CBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3927,
    stopColor: "#B2B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8BEE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_334_2901",
    x1: 73.0253,
    y1: 91.0217,
    x2: 111.859,
    y2: 210.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C1C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#CACEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3784,
    stopColor: "#B6BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9BFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_334_2901",
    x1: 72.9874,
    y1: 91.0376,
    x2: 111.819,
    y2: 210.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAC1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C4C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#CDD2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B9C0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#BAC1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_334_2901",
    x1: 72.9494,
    y1: 91.0535,
    x2: 111.78,
    y2: 210.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C6CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#D0D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D1D5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.361,
    stopColor: "#BDC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_334_2901",
    x1: 72.9114,
    y1: 91.0694,
    x2: 111.741,
    y2: 210.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2716,
    stopColor: "#D3D7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D5D9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3538,
    stopColor: "#C1C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9836,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_334_2901",
    x1: 72.8734,
    y1: 91.0853,
    x2: 111.702,
    y2: 210.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CBD1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2627,
    stopColor: "#D5D9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D9DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3478,
    stopColor: "#C5CAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9763,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_334_2901",
    x1: 72.8354,
    y1: 91.1012,
    x2: 111.663,
    y2: 210.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C6ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2591,
    stopColor: "#D8DCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#DDE0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3431,
    stopColor: "#C9CEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C6ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_334_2901",
    x1: 72.7974,
    y1: 91.117,
    x2: 111.624,
    y2: 210.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D0D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#DADEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#E1E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3388,
    stopColor: "#CDD1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9679,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C7EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_334_2901",
    x1: 72.7594,
    y1: 91.133,
    x2: 111.585,
    y2: 210.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#DDE1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#E4E7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3361,
    stopColor: "#D0D5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9656,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C9EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_334_2901",
    x1: 72.7214,
    y1: 91.1489,
    x2: 111.546,
    y2: 210.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D6DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2504,
    stopColor: "#E0E3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#E8EAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3328,
    stopColor: "#D4D8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_334_2901",
    x1: 72.6834,
    y1: 91.1648,
    x2: 111.507,
    y2: 211.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D8DDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#E2E6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3299,
    stopColor: "#D8DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9597,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_334_2901",
    x1: 72.6455,
    y1: 91.1806,
    x2: 111.468,
    y2: 211.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#DBDFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2439,
    stopColor: "#E5E8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#F0F1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3274,
    stopColor: "#DCDFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9581,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7CDF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_334_2901",
    x1: 72.6075,
    y1: 91.1965,
    x2: 111.429,
    y2: 211.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2404,
    stopColor: "#E7EAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#F4F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3252,
    stopColor: "#E0E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9551,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9CEF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_334_2901",
    x1: 72.5695,
    y1: 91.2126,
    x2: 111.39,
    y2: 211.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#E0E4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2404,
    stopColor: "#EAEDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#F7F8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E3E6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4066,
    stopColor: "#B1B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9539,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_334_2901",
    x1: 72.5315,
    y1: 91.2285,
    x2: 111.351,
    y2: 211.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#E2E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2374,
    stopColor: "#ECEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#FBFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3217,
    stopColor: "#E7EAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4009,
    stopColor: "#B5BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9514,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_334_2901",
    x1: 72.4935,
    y1: 91.2443,
    x2: 111.312,
    y2: 211.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2361,
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3201,
    stopColor: "#EBEDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3957,
    stopColor: "#B9BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9503,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_334_2901",
    x1: 10.883,
    y1: 184.048,
    x2: 147.854,
    y2: 127.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3485,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8551,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_334_2901",
    x1: 119.751,
    y1: 148.762,
    x2: 100.041,
    y2: 138.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3485,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8551,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_334_2901",
    x1: 103.306,
    y1: 139.749,
    x2: 85.5975,
    y2: 188.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#B5B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1722,
    stopColor: "#C3BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    stopColor: "#7870FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#372EC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_334_2901",
    x1: 108.428,
    y1: 142.252,
    x2: 26.6407,
    y2: 182.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1447,
    stopColor: "#90ED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#35D5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6263,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8217,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(261.273 49.0714) scale(25.2428 25.2428)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E1AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_334_2901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.208 98.2624) scale(23.7774 23.7774)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04E2AD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.79fa05a540dfa6df58eb18c9d27d99fa.svg";
export { ForwardRef as ReactComponent };